import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.string.trim";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.fill";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.object.assign";
import React from 'react';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var colors = {
  transparent: "transparent",
  black: "#000000",
  white: "#ffffff",
  gray: {
    100: "#f7fafc",
    200: "#edf2f7",
    300: "#e2e8f0",
    400: "#cbd5e0",
    500: "#a0aec0",
    600: "#718096",
    700: "#4a5568",
    800: "#2d3748",
    900: "#1a202c"
  },
  red: {
    100: "#fff5f5",
    200: "#fed7d7",
    300: "#feb2b2",
    400: "#fc8181",
    500: "#f56565",
    600: "#e53e3e",
    700: "#c53030",
    800: "#9b2c2c",
    900: "#742a2a"
  },
  orange: {
    100: "#fffaf0",
    200: "#feebc8",
    300: "#fbd38d",
    400: "#f6ad55",
    500: "#ed8936",
    600: "#dd6b20",
    700: "#c05621",
    800: "#9c4221",
    900: "#7b341e"
  },
  yellow: {
    100: "#fffff0",
    200: "#fefcbf",
    300: "#faf089",
    400: "#f6e05e",
    500: "#ecc94b",
    600: "#d69e2e",
    700: "#b7791f",
    800: "#975a16",
    900: "#744210"
  },
  green: {
    100: "#f0fff4",
    200: "#c6f6d5",
    300: "#9ae6b4",
    400: "#68d391",
    500: "#48bb78",
    600: "#38a169",
    700: "#2f855a",
    800: "#276749",
    900: "#22543d"
  },
  teal: {
    100: "#e6fffa",
    200: "#b2f5ea",
    300: "#81e6d9",
    400: "#4fd1c5",
    500: "#38b2ac",
    600: "#319795",
    700: "#2c7a7b",
    800: "#285e61",
    900: "#234e52"
  },
  blue: {
    100: "#ebf8ff",
    200: "#bee3f8",
    300: "#90cdf4",
    400: "#63b3ed",
    500: "#4299e1",
    600: "#3182ce",
    700: "#2b6cb0",
    800: "#2c5282",
    900: "#2a4365"
  },
  indigo: {
    100: "#ebf4ff",
    200: "#c3dafe",
    300: "#a3bffa",
    400: "#7f9cf5",
    500: "#667eea",
    600: "#5a67d8",
    700: "#4c51bf",
    800: "#434190",
    900: "#3c366b"
  },
  purple: {
    100: "#faf5ff",
    200: "#e9d8fd",
    300: "#d6bcfa",
    400: "#b794f4",
    500: "#9f7aea",
    600: "#805ad5",
    700: "#6b46c1",
    800: "#553c9a",
    900: "#44337a"
  },
  pink: {
    100: "#fff5f7",
    200: "#fed7e2",
    300: "#fbb6ce",
    400: "#f687b3",
    500: "#ed64a6",
    600: "#d53f8c",
    700: "#b83280",
    800: "#97266d",
    900: "#702459"
  }
};
var spacing = {
  px: "1px",
  "0": "0",
  "1": "0.25rem",
  "2": "0.5rem",
  "3": "0.75rem",
  "4": "1rem",
  "5": "1.25rem",
  "6": "1.5rem",
  "8": "2rem",
  "10": "2.5rem",
  "12": "3rem",
  "16": "4rem",
  "20": "5rem",
  "24": "6rem",
  "32": "8rem",
  "40": "10rem",
  "48": "12rem",
  "56": "14rem",
  "64": "16rem"
};
var screens = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px"
};
var fontFamily = {
  sans: ["-apple-system", "BlinkMacSystemFont", '"Segoe UI"', "Roboto", '"Helvetica Neue"', "Arial", '"Noto Sans"', "sans-serif", '"Apple Color Emoji"', '"Segoe UI Emoji"', '"Segoe UI Symbol"', '"Noto Color Emoji"'],
  serif: ["Georgia", "Cambria", '"Times New Roman"', "Times", "serif"],
  mono: ["Menlo", "Monaco", "Consolas", '"Liberation Mono"', '"Courier New"', "monospace"]
};
var fontSize = {
  xs: "0.75rem",
  sm: "0.875rem",
  base: "1rem",
  lg: "1.125rem",
  xl: "1.25rem",
  "2xl": "1.5rem",
  "3xl": "1.875rem",
  "4xl": "2.25rem",
  "5xl": "3rem",
  "6xl": "4rem"
};
var fontWeight = {
  hairline: 100,
  thin: 200,
  light: 300,
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  extrabold: 800,
  black: 900
};
var lineHeight = {
  none: 1,
  tight: 1.25,
  snug: 1.375,
  normal: 1.5,
  relaxed: 1.625,
  loose: 2
};
var letterSpacing = {
  tighter: "-.05em",
  tight: "-.025em",
  normal: "0",
  wide: ".025em",
  wider: ".05em",
  widest: ".1em"
};

var textColor =
/*#__PURE__*/
_extends$1({}, colors);

var backgroundColor =
/*#__PURE__*/
_extends$1({}, colors);

var backgroundPosition = {
  bottom: "bottom",
  center: "center",
  left: "left",
  "left-bottom": "left bottom",
  "left-top": "left top",
  right: "right",
  "right-bottom": "right bottom",
  "right-top": "right top",
  top: "top"
};
var backgroundSize = {
  auto: "auto",
  cover: "cover",
  contain: "contain"
};
var borderWidth = {
  "default": "1px",
  "0": "0",
  "2": "2px",
  "4": "4px",
  "8": "8px"
};

var borderColor =
/*#__PURE__*/
_extends$1({}, colors, {
  "default": colors.gray["300"]
});

var borderRadius = {
  none: "0",
  sm: ".125rem",
  "default": ".25rem",
  lg: ".5rem",
  full: "9999px"
};
var cursor = {
  auto: "auto",
  "default": "default",
  pointer: "pointer",
  wait: "wait",
  move: "move",
  "not-allowed": "not-allowed",
  help: "help",
  "context-menu": "context-menu",
  text: "text",
  alias: "alias",
  copy: "copy",
  grab: "grab",
  grabbing: "grabbing"
};

var width =
/*#__PURE__*/
_extends$1({
  auto: "auto"
}, spacing, {
  "1/2": "50%",
  "1/3": "33.33333%",
  "2/3": "66.66667%",
  "1/4": "25%",
  "2/4": "50%",
  "3/4": "75%",
  "1/5": "20%",
  "2/5": "40%",
  "3/5": "60%",
  "4/5": "80%",
  "1/6": "16.66667%",
  "2/6": "33.33333%",
  "3/6": "50%",
  "4/6": "66.66667%",
  "5/6": "83.33333%",
  "1/12": "8.33333%",
  "2/12": "16.66667%",
  "3/12": "25%",
  "4/12": "33.33333%",
  "5/12": "41.66667%",
  "6/12": "50%",
  "7/12": "58.33333%",
  "8/12": "66.66667%",
  "9/12": "75%",
  "10/12": "83.33333%",
  "11/12": "91.66667%",
  full: "100%",
  screen: "100vw"
});

var height =
/*#__PURE__*/
_extends$1({
  auto: "auto"
}, spacing, {
  full: "100%",
  screen: "100vh"
});

var minWidth = {
  "0": "0",
  full: "100%"
};
var minHeight = {
  "0": "0",
  full: "100%",
  screen: "100vh"
};
var maxWidth = {
  xs: "20rem",
  sm: "24rem",
  md: "28rem",
  lg: "32rem",
  xl: "36rem",
  "2xl": "42rem",
  "3xl": "48rem",
  "4xl": "56rem",
  "5xl": "64rem",
  "6xl": "72rem",
  full: "100%",
  screen: "100vw"
};
var maxHeight = {
  full: "100%",
  screen: "100vh"
};

var padding =
/*#__PURE__*/
_extends$1({}, spacing);

var margin =
/*#__PURE__*/
_extends$1({
  auto: "auto"
}, spacing);

var negativeMargin =
/*#__PURE__*/
_extends$1({}, spacing);

var objectPosition = {
  bottom: "bottom",
  center: "center",
  left: "left",
  "left-bottom": "left bottom",
  "left-top": "left top",
  right: "right",
  "right-bottom": "right bottom",
  "right-top": "right top",
  top: "top"
};
var boxShadow = {
  "default": "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
  md: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
  lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
  xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
  "2xl": "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
  inner: "inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)",
  outline: "0 0 0 3px rgba(66, 153, 225, 0.5)",
  none: "none"
};
var zIndex = {
  auto: "auto",
  "0": 0,
  "10": 10,
  "20": 20,
  "30": 30,
  "40": 40,
  "50": 50
};
var opacity = {
  "0": "0",
  "25": ".25",
  "50": ".5",
  "75": ".75",
  "100": "1"
};
var fill = {
  current: "currentColor"
};
var stroke = {
  current: "currentColor"
};
var flex = {
  "1": "1 1 0%",
  auto: "1 1 auto",
  initial: "0 1 auto",
  none: "none"
};
var flexGrow = {
  "0": 0,
  "default": 1
};
var flexShrink = {
  "0": 0,
  "default": 1
};
var order = {
  first: -9999,
  last: 9999,
  none: 0,
  "1": 1,
  "2": 2,
  "3": 3,
  "4": 4,
  "5": 5,
  "6": 6,
  "7": 7,
  "8": 8,
  "9": 9,
  "10": 10,
  "11": 11,
  "12": 12
};
var listStyleType = {
  none: "none",
  circle: "circle",
  disc: "disc",
  decimal: "decimal",
  square: "square"
};
var inset = {
  "0": 0,
  auto: "auto"
};
var theme = {
  colors: colors,
  spacing: spacing,
  screens: screens,
  fontFamily: fontFamily,
  fontSize: fontSize,
  fontWeight: fontWeight,
  lineHeight: lineHeight,
  letterSpacing: letterSpacing,
  textColor: textColor,
  backgroundColor: backgroundColor,
  backgroundPosition: backgroundPosition,
  backgroundSize: backgroundSize,
  borderWidth: borderWidth,
  borderColor: borderColor,
  borderRadius: borderRadius,
  cursor: cursor,
  width: width,
  height: height,
  minWidth: minWidth,
  maxWidth: maxWidth,
  minHeight: minHeight,
  maxHeight: maxHeight,
  padding: padding,
  margin: margin,
  negativeMargin: negativeMargin,
  objectPosition: objectPosition,
  boxShadow: boxShadow,
  zIndex: zIndex,
  opacity: opacity,
  fill: fill,
  stroke: stroke,
  flex: flex,
  flexGrow: flexGrow,
  flexShrink: flexShrink,
  order: order,
  listStyleType: listStyleType,
  inset: inset
};

function generate() {
  return {
    "content-start": {
      "align-content": "flex-start"
    },
    "content-end": {
      "align-content": "flex-end"
    },
    "content-center": {
      "align-content": "center"
    },
    "content-between": {
      "align-content": "space-between"
    },
    "content-around": {
      "align-content": "space-around"
    }
  };
}

function generate$1() {
  return {
    "items-start": {
      "align-items": "flex-start"
    },
    "items-end": {
      "align-items": "flex-end"
    },
    "items-center": {
      "align-items": "center"
    },
    "items-baseline": {
      "align-items": "baseline"
    },
    "items-stretch": {
      "align-items": "stretch"
    }
  };
}

function generate$2() {
  return {
    "self-auto": {
      "align-self": "auto"
    },
    "self-start": {
      "align-self": "flex-start"
    },
    "self-end": {
      "align-self": "flex-end"
    },
    "self-center": {
      "align-self": "center"
    },
    "self-stretch": {
      "align-self": "stretch"
    }
  };
}

function generate$3() {
  return {
    "appearance-none": {
      appearance: "none"
    }
  };
}

function createUtilitiesFromMap(map, generateDeclarations, prefix) {
  if (map === void 0) {
    map = {};
  }

  if (prefix === void 0) {
    prefix = "";
  }

  if (!map) {
    return {};
  }

  return Object.keys(map).reduce(function (utilities, key) {
    var value = map[key];
    var label = Array.isArray(map) ? value : key;
    var className = [prefix, label === "default" ? null : label].filter(Boolean).join("-");
    var declarations = generateDeclarations(value);
    utilities[className] = declarations;
    return utilities;
  }, {});
}

var backgroundAttachment = ["fixed", "local", "scroll"];

function generate$4() {
  return createUtilitiesFromMap(backgroundAttachment, function (value) {
    return {
      "background-attachment": value
    };
  }, "bg");
}

function flattenColor(name, value) {
  if (typeof value !== "object") {
    var _ref;

    return _ref = {}, _ref[name] = value, _ref;
  }

  return Object.keys(value).reduce(function (colorVariants, colorVariation) {
    var _extends2;

    return _extends$1({}, colorVariants, (_extends2 = {}, _extends2["" + name + (colorVariation !== "default" ? "-" + colorVariation : "")] = value[colorVariation], _extends2));
  }, {});
}

function flattenColorConfig(colorConfig) {
  if (colorConfig === void 0) {
    colorConfig = {};
  }

  return Object.keys(colorConfig).reduce(function (colors, colorName) {
    return _extends$1({}, colors, {}, flattenColor(colorName, colorConfig[colorName]));
  }, {});
}

function generate$5(theme) {
  var _theme$backgroundColo = theme.backgroundColor,
      backgroundColor = _theme$backgroundColo === void 0 ? {} : _theme$backgroundColo;
  return createUtilitiesFromMap(flattenColorConfig(backgroundColor), function (value) {
    return {
      "background-color": value
    };
  }, "bg");
}

function generate$6(theme) {
  var _theme$backgroundPosi = theme.backgroundPosition,
      backgroundPosition = _theme$backgroundPosi === void 0 ? {} : _theme$backgroundPosi;
  return createUtilitiesFromMap(backgroundPosition, function (value) {
    return {
      "background-position": value
    };
  }, "bg");
}

var backgroundRepeat = {
  repeat: "repeat",
  "repeat-round": "round",
  "repeat-space": "space",
  "no-repeat": "no-repeat",
  "repeat-x": "repeat-x",
  "repeat-y": "repeat-y",
  space: "space",
  round: "round"
};

function generate$7() {
  return createUtilitiesFromMap(backgroundRepeat, function (value) {
    return {
      "background-repeat": value
    };
  }, "bg");
}

function generate$8(theme) {
  var backgroundSize = theme.backgroundSize;
  return createUtilitiesFromMap(backgroundSize, function (value) {
    return {
      "background-size": value
    };
  }, "bg");
}

function generate$9() {
  return createUtilitiesFromMap(["collapse", "separate"], function (value) {
    return {
      "border-collapse": value
    };
  }, "border");
}

function generate$a(theme) {
  var _theme$borderColor = theme.borderColor,
      borderColor = _theme$borderColor === void 0 ? {} : _theme$borderColor;
  return createUtilitiesFromMap(flattenColorConfig(borderColor), function (value) {
    return {
      "border-color": value
    };
  }, "border");
}

function generate$b(theme) {
  var _theme$borderRadius = theme.borderRadius,
      borderRadius = _theme$borderRadius === void 0 ? {} : _theme$borderRadius;
  return _extends$1({}, createUtilitiesFromMap(borderRadius, function (value) {
    return {
      "border-radius": value
    };
  }, "rounded"), {}, createUtilitiesFromMap(borderRadius, function (value) {
    return {
      "border-top-left-radius": value,
      "border-top-right-radius": value
    };
  }, "rounded-t"), {}, createUtilitiesFromMap(borderRadius, function (value) {
    return {
      "border-top-right-radius": value,
      "border-bottom-right-radius": value
    };
  }, "rounded-r"), {}, createUtilitiesFromMap(borderRadius, function (value) {
    return {
      "border-bottom-right-radius": value,
      "border-bottom-left-radius": value
    };
  }, "rounded-b"), {}, createUtilitiesFromMap(borderRadius, function (value) {
    return {
      "border-top-left-radius": value,
      "border-bottom-left-radius": value
    };
  }, "rounded-l"), {}, createUtilitiesFromMap(borderRadius, function (value) {
    return {
      "border-top-left-radius": value
    };
  }, "rounded-tl"), {}, createUtilitiesFromMap(borderRadius, function (value) {
    return {
      "border-top-right-radius": value
    };
  }, "rounded-tr"), {}, createUtilitiesFromMap(borderRadius, function (value) {
    return {
      "border-bottom-right-radius": value
    };
  }, "rounded-br"), {}, createUtilitiesFromMap(borderRadius, function (value) {
    return {
      "border-bottom-left-radius": value
    };
  }, "rounded-bl"));
}

var borderStyles = ["solid", "dashed", "dotted", "none"];

function generate$c() {
  return createUtilitiesFromMap(borderStyles, function (value) {
    return {
      "border-style": value
    };
  }, "border");
}

function generate$d(theme) {
  var _theme$borderWidth = theme.borderWidth,
      borderWidth = _theme$borderWidth === void 0 ? {} : _theme$borderWidth;
  return _extends$1({}, createUtilitiesFromMap(borderWidth, function (value) {
    return {
      "border-width": value
    };
  }, "border"), {}, createUtilitiesFromMap(borderWidth, function (value) {
    return {
      "border-top-width": value
    };
  }, "border-t"), {}, createUtilitiesFromMap(borderWidth, function (value) {
    return {
      "border-right-width": value
    };
  }, "border-r"), {}, createUtilitiesFromMap(borderWidth, function (value) {
    return {
      "border-bottom-width": value
    };
  }, "border-b"), {}, createUtilitiesFromMap(borderWidth, function (value) {
    return {
      "border-left-width": value
    };
  }, "border-l"));
}

function generate$e(theme) {
  var _theme$boxShadow = theme.boxShadow,
      boxShadow = _theme$boxShadow === void 0 ? {} : _theme$boxShadow;
  return createUtilitiesFromMap(boxShadow, function (value) {
    return {
      "box-shadow": value
    };
  }, "shadow");
}

function generate$f(theme) {
  var _theme$screens = theme.screens,
      screens = _theme$screens === void 0 ? {} : _theme$screens;
  return {
    container: _extends$1({
      width: "100%"
    }, Object.keys(screens).reduce(function (mediaQueries, containerSize) {
      var _extends2;

      return _extends$1({}, mediaQueries, (_extends2 = {}, _extends2["@media (min-width: " + screens[containerSize] + ")"] = {
        "max-width": screens[containerSize]
      }, _extends2));
    }, {}))
  };
}

function generate$g(theme) {
  var _theme$cursor = theme.cursor,
      cursor = _theme$cursor === void 0 ? {} : _theme$cursor;
  return _extends$1({
    "cursor-default": {
      cursor: "default"
    }
  }, createUtilitiesFromMap(cursor, function (value) {
    return {
      cursor: value
    };
  }, "cursor"));
}

var displayVariants = ["block", "inline-block", "inline", "table", "table-row", "table-cell", "flex", "inline-flex"];

function generate$h() {
  return _extends$1({}, createUtilitiesFromMap(displayVariants, function (value) {
    return {
      display: value
    };
  }), {
    hidden: {
      display: "none"
    }
  });
}

function generate$i(theme) {
  var _theme$fill = theme.fill,
      fill = _theme$fill === void 0 ? {} : _theme$fill;
  return createUtilitiesFromMap(fill, function (value) {
    return {
      fill: value
    };
  }, "fill");
}

function generate$j(theme) {
  var _theme$flex = theme.flex,
      flex = _theme$flex === void 0 ? {} : _theme$flex,
      _theme$order = theme.order,
      order = _theme$order === void 0 ? {} : _theme$order;
  return _extends$1({}, createUtilitiesFromMap(flex, function (value) {
    return {
      flex: value
    };
  }, "flex"), {}, createUtilitiesFromMap(order, function (value) {
    return {
      order: value
    };
  }, "order"));
}

function generate$k() {
  return {
    "flex-row": {
      "flex-direction": "row"
    },
    "flex-row-reverse": {
      "flex-direction": "row-reverse"
    },
    "flex-col": {
      "flex-direction": "column"
    },
    "flex-col-reverse": {
      "flex-direction": "column-reverse"
    }
  };
}

function generate$l(theme) {
  var _theme$flexGrow = theme.flexGrow,
      flexGrow = _theme$flexGrow === void 0 ? {} : _theme$flexGrow;
  return createUtilitiesFromMap(flexGrow, function (value) {
    return {
      "flex-grow": value
    };
  }, "flex-grow");
}

function generate$m(theme) {
  var _theme$flexShrink = theme.flexShrink,
      flexShrink = _theme$flexShrink === void 0 ? {} : _theme$flexShrink;
  return createUtilitiesFromMap(flexShrink, function (value) {
    return {
      "flex-shrink": value
    };
  }, "flex-shrink");
}

function generate$n() {
  return {
    "flex-wrap": {
      "flex-wrap": "wrap"
    },
    "flex-wrap-reverse": {
      "flex-wrap": "wrap-reverse"
    },
    "flex-no-wrap": {
      "flex-wrap": "nowrap"
    }
  };
}

function generate$o() {
  return _extends$1({
    clearfix: {
      "&::after": {
        content: "''",
        display: "table",
        clear: "both"
      }
    }
  }, createUtilitiesFromMap(["right", "left", "none"], function (value) {
    return {
      "float": value
    };
  }, "float"));
}

function generate$p(theme) {
  var _theme$fontFamily = theme.fontFamily,
      fontFamily = _theme$fontFamily === void 0 ? {} : _theme$fontFamily;
  return createUtilitiesFromMap(fontFamily, function (value) {
    return {
      "font-family": value.join(",")
    };
  }, "font");
}

function generate$q(theme) {
  var _theme$fontSize = theme.fontSize,
      fontSize = _theme$fontSize === void 0 ? {} : _theme$fontSize;
  return createUtilitiesFromMap(fontSize, function (value) {
    return {
      "font-size": value
    };
  }, "text");
}

function generate$r() {
  return {
    antialiased: {
      "-webkit-font-smoothing": "antialiased",
      "-moz-osx-font-smoothing": "antialiased"
    },
    "subpixel-antialiased": {
      "-webkit-font-smoothing": "auto",
      "-moz-osx-font-smoothing": "auto"
    }
  };
}

function generate$s() {
  return {
    italic: {
      "font-style": "italic"
    },
    "not-italic": {
      "font-style": "normal"
    }
  };
}

function generate$t(theme) {
  var _theme$fontWeight = theme.fontWeight,
      fontWeight = _theme$fontWeight === void 0 ? {} : _theme$fontWeight;
  return createUtilitiesFromMap(fontWeight, function (value) {
    return {
      "font-weight": value
    };
  }, "font");
}

function generate$u(theme) {
  var _theme$height = theme.height,
      height = _theme$height === void 0 ? {} : _theme$height,
      _theme$maxHeight = theme.maxHeight,
      maxHeight = _theme$maxHeight === void 0 ? {} : _theme$maxHeight,
      _theme$minHeight = theme.minHeight,
      minHeight = _theme$minHeight === void 0 ? {} : _theme$minHeight;
  return _extends$1({}, createUtilitiesFromMap(height, function (value) {
    return {
      height: value
    };
  }, "h"), {}, createUtilitiesFromMap(maxHeight, function (value) {
    return {
      "max-height": value
    };
  }, "max-h"), {}, createUtilitiesFromMap(minHeight, function (value) {
    return {
      "min-height": value
    };
  }, "min-h"));
}

function generate$v(theme) {
  var _theme$inset = theme.inset,
      inset = _theme$inset === void 0 ? {} : _theme$inset;
  return _extends$1({}, createUtilitiesFromMap(inset, function (value) {
    return {
      top: value,
      right: value,
      bottom: value,
      left: value
    };
  }, "inset"), {}, createUtilitiesFromMap(inset, function (value) {
    return {
      right: value,
      left: value
    };
  }, "inset-x"), {}, createUtilitiesFromMap(inset, function (value) {
    return {
      top: value,
      bottom: value
    };
  }, "inset-y"), {}, createUtilitiesFromMap(inset, function (value) {
    return {
      top: value
    };
  }, "top"), {}, createUtilitiesFromMap(inset, function (value) {
    return {
      right: value
    };
  }, "right"), {}, createUtilitiesFromMap(inset, function (value) {
    return {
      bottom: value
    };
  }, "bottom"), {}, createUtilitiesFromMap(inset, function (value) {
    return {
      left: value
    };
  }, "left"));
}

function generate$w() {
  return {
    "justify-start": {
      "justify-content": "flex-start"
    },
    "justify-end": {
      "justify-content": "flex-end"
    },
    "justify-center": {
      "justify-content": "center"
    },
    "justify-between": {
      "justify-content": "space-between"
    },
    "justify-around": {
      "justify-content": "space-around"
    }
  };
}

function generate$x(theme) {
  var _theme$letterSpacing = theme.letterSpacing,
      letterSpacing = _theme$letterSpacing === void 0 ? {} : _theme$letterSpacing;
  return createUtilitiesFromMap(letterSpacing, function (value) {
    return {
      "letter-spacing": value
    };
  }, "tracking");
}

function generate$y(theme) {
  var _theme$lineHeight = theme.lineHeight,
      lineHeight = _theme$lineHeight === void 0 ? {} : _theme$lineHeight;
  return createUtilitiesFromMap(lineHeight, function (value) {
    return {
      "line-height": value
    };
  }, "leading");
}

function generate$z() {
  return {
    "list-inside": {
      "list-style-position": "inside"
    },
    "list-outside": {
      "list-style-position": "outside"
    }
  };
}

function generate$A(theme) {
  var _theme$listStyleType = theme.listStyleType,
      listStyleType = _theme$listStyleType === void 0 ? {} : _theme$listStyleType;
  return createUtilitiesFromMap(listStyleType, function (value) {
    return {
      "list-style-type": value
    };
  }, "list");
}

function generate$B(theme) {
  var _theme$margin = theme.margin,
      margin = _theme$margin === void 0 ? {} : _theme$margin,
      _theme$negativeMargin = theme.negativeMargin,
      negativeMargin = _theme$negativeMargin === void 0 ? {} : _theme$negativeMargin;
  return _extends$1({}, createUtilitiesFromMap(margin, function (value) {
    return {
      margin: value
    };
  }, "m"), {}, createUtilitiesFromMap(margin, function (value) {
    return {
      "margin-left": value,
      "margin-right": value
    };
  }, "mx"), {}, createUtilitiesFromMap(margin, function (value) {
    return {
      "margin-top": value,
      "margin-bottom": value
    };
  }, "my"), {}, createUtilitiesFromMap(margin, function (value) {
    return {
      "margin-top": value
    };
  }, "mt"), {}, createUtilitiesFromMap(margin, function (value) {
    return {
      "margin-right": value
    };
  }, "mr"), {}, createUtilitiesFromMap(margin, function (value) {
    return {
      "margin-bottom": value
    };
  }, "mb"), {}, createUtilitiesFromMap(margin, function (value) {
    return {
      "margin-left": value
    };
  }, "ml"), {}, createUtilitiesFromMap(negativeMargin, function (value) {
    return {
      margin: "-" + value
    };
  }, "-m"), {}, createUtilitiesFromMap(negativeMargin, function (value) {
    return {
      "margin-left": "-" + value,
      "margin-right": "-" + value
    };
  }, "-mx"), {}, createUtilitiesFromMap(negativeMargin, function (value) {
    return {
      "margin-top": "-" + value,
      "margin-bottom": "-" + value
    };
  }, "-my"), {}, createUtilitiesFromMap(negativeMargin, function (value) {
    return {
      "margin-top": "-" + value
    };
  }, "-mt"), {}, createUtilitiesFromMap(negativeMargin, function (value) {
    return {
      "margin-right": "-" + value
    };
  }, "-mr"), {}, createUtilitiesFromMap(negativeMargin, function (value) {
    return {
      "margin-bottom": "-" + value
    };
  }, "-mb"), {}, createUtilitiesFromMap(negativeMargin, function (value) {
    return {
      "margin-left": "-" + value
    };
  }, "-ml"));
}

function generate$C() {
  return createUtilitiesFromMap(["contain", "cover", "fill", "none", "scale-down"], function (value) {
    return {
      "object-fit": value
    };
  }, "object");
}

function generate$D(theme) {
  var _theme$objectPosition = theme.objectPosition,
      objectPosition = _theme$objectPosition === void 0 ? {} : _theme$objectPosition;
  return createUtilitiesFromMap(objectPosition, function (value) {
    return {
      "object-position": value
    };
  }, "object");
}

function generate$E(theme) {
  var _theme$opacity = theme.opacity,
      opacity = _theme$opacity === void 0 ? {} : _theme$opacity;
  return createUtilitiesFromMap(opacity, function (value) {
    return {
      opacity: value
    };
  }, "opacity");
}

function generate$F() {
  return {
    "outline-none": {
      outline: 0
    }
  };
}

function generate$G() {
  return {
    "overflow-auto": {
      overflow: "auto"
    },
    "overflow-hidden": {
      overflow: "hidden"
    },
    "overflow-visible": {
      overflow: "visible"
    },
    "overflow-scroll": {
      overflow: "scroll"
    },
    "overflow-x-auto": {
      "overflow-x": "auto"
    },
    "overflow-y-auto": {
      "overflow-y": "auto"
    },
    "overflow-x-hidden": {
      "overflow-x": "hidden"
    },
    "overflow-y-hidden": {
      "overflow-y": "hidden"
    },
    "overflow-x-visible": {
      "overflow-x": "visible"
    },
    "overflow-y-visible": {
      "overflow-y": "visible"
    },
    "overflow-x-scroll": {
      "overflow-x": "scroll"
    },
    "overflow-y-scroll": {
      "overflow-y": "scroll"
    },
    "scrolling-touch": {
      "-webkit-overflow-scrolling": "touch"
    },
    "scrolling-auto": {
      "-webkit-overflow-scrolling": "auto"
    }
  };
}

function generate$H(theme) {
  var _theme$padding = theme.padding,
      padding = _theme$padding === void 0 ? {} : _theme$padding;
  return _extends$1({}, createUtilitiesFromMap(padding, function (value) {
    return {
      padding: value
    };
  }, "p"), {}, createUtilitiesFromMap(padding, function (value) {
    return {
      "padding-left": value,
      "padding-right": value
    };
  }, "px"), {}, createUtilitiesFromMap(padding, function (value) {
    return {
      "padding-top": value,
      "padding-bottom": value
    };
  }, "py"), {}, createUtilitiesFromMap(padding, function (value) {
    return {
      "padding-top": value
    };
  }, "pt"), {}, createUtilitiesFromMap(padding, function (value) {
    return {
      "padding-right": value
    };
  }, "pr"), {}, createUtilitiesFromMap(padding, function (value) {
    return {
      "padding-bottom": value
    };
  }, "pb"), {}, createUtilitiesFromMap(padding, function (value) {
    return {
      "padding-left": value
    };
  }, "pl"));
}

function generate$I() {
  return {
    "pointer-events-none": {
      "pointer-events": "none"
    },
    "pointer-events-auto": {
      "pointer-events": "auto"
    }
  };
}

function generate$J(theme) {
  var inset = theme.inset;
  return _extends$1({
    "static": {
      position: "static"
    },
    fixed: {
      position: "fixed"
    },
    absolute: {
      position: "absolute"
    },
    relative: {
      position: "relative"
    },
    sticky: {
      position: "sticky"
    }
  }, createUtilitiesFromMap(inset, function (value) {
    return {
      top: value,
      right: value,
      bottom: value,
      left: value
    };
  }, "inset"), {}, createUtilitiesFromMap(inset, function (value) {
    return {
      right: value,
      left: value
    };
  }, "inset-x"), {}, createUtilitiesFromMap(inset, function (value) {
    return {
      top: value,
      bottom: value
    };
  }, "inset-y"), {}, createUtilitiesFromMap(inset, function (value) {
    return {
      top: value
    };
  }, "top"), {}, createUtilitiesFromMap(inset, function (value) {
    return {
      right: value
    };
  }, "right"), {}, createUtilitiesFromMap(inset, function (value) {
    return {
      bottom: value
    };
  }, "bottom"), {}, createUtilitiesFromMap(inset, function (value) {
    return {
      left: value
    };
  }, "left"));
}

function generate$K() {
  return {
    "resize-none": {
      resize: "none"
    },
    "resize-x": {
      resize: "horizontal"
    },
    "resize-y": {
      resize: "vertical"
    },
    resize: {
      resize: "both"
    }
  };
}

function generate$L(theme) {
  var _theme$stroke = theme.stroke,
      stroke = _theme$stroke === void 0 ? {} : _theme$stroke;
  return createUtilitiesFromMap(stroke, function (value) {
    return {
      stroke: value
    };
  }, "stroke");
}

function generate$M() {
  return {
    "table-auto": {
      "table-layout": "auto"
    },
    "table-fixed": {
      "table-layout": "fixed"
    }
  };
}

function generate$N() {
  return {
    "text-left": {
      "text-align": "left"
    },
    "text-right": {
      "text-align": "right"
    },
    "text-center": {
      "text-align": "center"
    },
    "text-justify": {
      "text-align": "justify"
    }
  };
}

function generate$O(theme) {
  var _theme$textColor = theme.textColor,
      textColor = _theme$textColor === void 0 ? {} : _theme$textColor;
  return createUtilitiesFromMap(flattenColorConfig(textColor), function (value) {
    return {
      color: value
    };
  }, "text");
}

function generate$P() {
  return {
    underline: {
      "text-decoration": "underline"
    },
    "line-through": {
      "text-decoration": "line-through"
    },
    "no-underline": {
      "text-decoration": "none"
    }
  };
}

function generate$Q() {
  return {
    uppercase: {
      "text-transform": "uppercase"
    },
    lowercase: {
      "text-transform": "lowercase"
    },
    capitalize: {
      "text-transform": "capitalize"
    },
    "normal-case": {
      "text-transform": "none"
    }
  };
}

function generate$R() {
  return {
    "select-all": {
      "user-select": "all"
    },
    "select-auto": {
      "user-select": "auto"
    },
    "select-none": {
      "user-select": "none"
    },
    "select-text": {
      "user-select": "text"
    }
  };
}

function generate$S() {
  return createUtilitiesFromMap(["baseline", "top", "middle", "bottom", "text-top", "text-bottom"], function (value) {
    return {
      "vertical-align": value
    };
  }, "align");
}

function generate$T() {
  return {
    visible: {
      visibility: "visible"
    },
    invisible: {
      visibility: "hidden"
    }
  };
}

function generate$U() {
  return {
    "whitespace-normal": {
      "white-space": "normal"
    },
    "whitespace-no-wrap": {
      "white-space": "nowrap"
    },
    "whitespace-pre": {
      "white-space": "pre"
    },
    "whitespace-pre-line": {
      "white-space": "pre-line"
    },
    "whitespace-pre-wrap": {
      "white-space": "pre-wrap"
    }
  };
}

function generate$V(theme) {
  var _theme$width = theme.width,
      width = _theme$width === void 0 ? {} : _theme$width,
      _theme$maxWidth = theme.maxWidth,
      maxWidth = _theme$maxWidth === void 0 ? {} : _theme$maxWidth,
      _theme$minWidth = theme.minWidth,
      minWidth = _theme$minWidth === void 0 ? {} : _theme$minWidth;
  return _extends$1({}, createUtilitiesFromMap(width, function (value) {
    return {
      width: value
    };
  }, "w"), {}, createUtilitiesFromMap(maxWidth, function (value) {
    return {
      "max-width": value
    };
  }, "max-w"), {}, createUtilitiesFromMap(minWidth, function (value) {
    return {
      "min-width": value
    };
  }, "min-w"));
}

function generate$W() {
  return {
    "break-normal": {
      "overflow-wrap": "normal",
      "word-break": "normal"
    },
    "break-words": {
      "overflow-wrap": "break-word"
    },
    "break-all": {
      "word-break": "break-all"
    },
    truncate: {
      overflow: "hidden",
      "text-overflow": "ellipsis",
      "white-space": "nowrap"
    }
  };
}

function generate$X(theme) {
  var zIndex = theme.zIndex;
  return createUtilitiesFromMap(zIndex, function (value) {
    return {
      "z-index": value
    };
  }, "z");
}

var utilities = [generate$f, // accessibility
generate$3, generate$4, generate$5, generate$6, generate$7, generate$8, generate$9, generate$a, generate$b, generate$c, generate$d, generate$g, generate$h, generate$k, generate$n, generate$1, generate$2, generate$w, generate, generate$j, generate$l, generate$m, // order
generate$o, generate$p, generate$t, generate$u, generate$y, generate$z, generate$A, generate$B, // maxHeight,
//  maxWidth,
//  minHeight,
//  minWidth,
generate$C, generate$D, generate$E, generate$F, generate$G, generate$H, // placeholderColor,
generate$I, generate$J, generate$v, generate$K, generate$e, generate$i, generate$L, generate$M, generate$N, generate$O, generate$q, generate$s, generate$Q, generate$P, generate$r, generate$x, generate$R, generate$S, generate$T, generate$U, generate$W, generate$V, generate$X];

function createVariant(utilities, generateDeclarations, prefix) {
  if (!utilities) {
    return {};
  }

  return Object.keys(utilities).reduce(function (variants, utilityKey) {
    variants[prefix + ":" + utilityKey] = generateDeclarations(utilities[utilityKey]);
    return variants;
  }, {});
}

function generate$Y(utilityMap) {
  return createVariant(utilityMap, function (value) {
    return {
      "&:active": value
    };
  }, "active");
}

function generate$Z(utilityMap) {
  return createVariant(utilityMap, function (value) {
    return {
      "&:focus": value
    };
  }, "focus");
}

function generate$_(utilityMap) {
  return createVariant(utilityMap, function (value) {
    return {
      "&:focus-within": value
    };
  }, "focus-within");
}

function generate$$(utilityMap) {
  return createVariant(utilityMap, function (value) {
    return {
      "&:hover": value
    };
  }, "hover");
}

function createVariantsFromMap(utilities, map, generateDeclarations) {
  if (!map) {
    return {};
  }

  return Object.keys(map).reduce(function (variants, key) {
    var v = createVariant(utilities, function (value) {
      return generateDeclarations(map[key], value);
    }, key);
    Object.keys(v).forEach(function (className) {
      variants[className] = v[className];
    });
    return variants;
  }, {});
}

function generate$10(utilities, theme) {
  var _theme$screens = theme.screens,
      screens = _theme$screens === void 0 ? {} : _theme$screens;
  return createVariantsFromMap(utilities, screens, function (variantValue, declarations) {
    var _ref;

    return _ref = {}, _ref["@media(min-width: " + variantValue + ")"] = declarations, _ref;
  });
}

var variants = [generate$Y, generate$Z, generate$_, generate$$, generate$10];
var defaultConfig = {
  prefix: "",
  theme: theme,
  utilities: utilities,
  variants: variants
};

function createUtilityMap(allUtilities, theme) {
  if (allUtilities === void 0) {
    allUtilities = [];
  }

  if (theme === void 0) {
    theme = {};
  }

  var map = {};

  var _loop = function _loop(i) {
    var utilityFn = allUtilities[i];
    var rulesMap = utilityFn(theme) || {};
    Object.keys(rulesMap).forEach(function (key) {
      map[key] = rulesMap[key];
    });
  };

  for (var i = 0; i < allUtilities.length; i++) {
    _loop(i);
  }

  return map;
}

function createVariantMap(allVariants, utilityMap, theme) {
  if (allVariants === void 0) {
    allVariants = [];
  }

  if (utilityMap === void 0) {
    utilityMap = {};
  }

  if (theme === void 0) {
    theme = {};
  }

  var map = {};

  var _loop = function _loop(i) {
    var variantFn = allVariants[i];
    var rulesMap = variantFn(utilityMap, theme) || {};
    Object.keys(rulesMap).forEach(function (key) {
      map[key] = rulesMap[key];
    });
  };

  for (var i = 0; i < allVariants.length; i++) {
    _loop(i);
  }

  return map;
}

function formatDeclaration(property, value, isImportant) {
  if (isImportant === void 0) {
    isImportant = false;
  }

  var declaration = property + ": " + value;
  return "" + declaration + (isImportant ? " !important" : "") + ";";
}

function parseDeclarations(declarations, isImportant) {
  if (declarations === void 0) {
    declarations = {};
  }

  if (isImportant === void 0) {
    isImportant = false;
  }

  return Object.keys(declarations).map(function (property) {
    if (property.match(/[&@]/)) {
      // Assume we have a nested selector
      var nestedDeclarations = parseDeclarations(declarations[property], isImportant);
      return property + " { " + nestedDeclarations.join("") + " }";
    }

    return formatDeclaration(property, declarations[property], isImportant);
  });
}

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var stylis =
/*#__PURE__*/
createCommonjsModule(function (module, exports) {
  /*
   *          __        ___
   *    _____/ /___  __/ (_)____
   *   / ___/ __/ / / / / / ___/
   *  (__  ) /_/ /_/ / / (__  )
   * /____/\__/\__, /_/_/____/
   *          /____/
   *
   * light - weight css preprocessor @licence MIT
   */
  (function (factory) {
    /* eslint-disable */
    module['exports'] = factory(null);
  })(
  /** @param {*=} options */
  function factory(options) {
    /**
     * Notes
     *
     * The ['<method name>'] pattern is used to support closure compiler
     * the jsdoc signatures are also used to the same effect
     *
     * ----
     *
     * int + int + int === n4 [faster]
     *
     * vs
     *
     * int === n1 && int === n2 && int === n3
     *
     * ----
     *
     * switch (int) { case ints...} [faster]
     *
     * vs
     *
     * if (int == 1 && int === 2 ...)
     *
     * ----
     *
     * The (first*n1 + second*n2 + third*n3) format used in the property parser
     * is a simple way to hash the sequence of characters
     * taking into account the index they occur in
     * since any number of 3 character sequences could produce duplicates.
     *
     * On the other hand sequences that are directly tied to the index of the character
     * resolve a far more accurate measure, it's also faster
     * to evaluate one condition in a switch statement
     * than three in an if statement regardless of the added math.
     *
     * This allows the vendor prefixer to be both small and fast.
     */
    var nullptn = /^\0+/g;
    /* matches leading null characters */

    var formatptn = /[\0\r\f]/g;
    /* matches new line, null and formfeed characters */

    var colonptn = /: */g;
    /* splits animation rules */

    var cursorptn = /zoo|gra/;
    /* assert cursor varient */

    var transformptn = /([,: ])(transform)/g;
    /* vendor prefix transform, older webkit */

    var animationptn = /,+\s*(?![^(]*[)])/g;
    /* splits multiple shorthand notation animations */

    var propertiesptn = / +\s*(?![^(]*[)])/g;
    /* animation properties */

    var elementptn = / *[\0] */g;
    /* selector elements */

    var selectorptn = /,\r+?/g;
    /* splits selectors */

    var andptn = /([\t\r\n ])*\f?&/g;
    /* match & */

    var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g;
    /* matches :global(.*) */

    var invalidptn = /\W+/g;
    /* removes invalid characters from keyframes */

    var keyframeptn = /@(k\w+)\s*(\S*)\s*/;
    /* matches @keyframes $1 */

    var plcholdrptn = /::(place)/g;
    /* match ::placeholder varient */

    var readonlyptn = /:(read-only)/g;
    /* match :read-only varient */

    var beforeptn = /\s+(?=[{\];=:>])/g;
    /* matches \s before ] ; = : */

    var afterptn = /([[}=:>])\s+/g;
    /* matches \s after characters [ } = : */

    var tailptn = /(\{[^{]+?);(?=\})/g;
    /* matches tail semi-colons ;} */

    var whiteptn = /\s{2,}/g;
    /* matches repeating whitespace */

    var pseudoptn = /([^\(])(:+) */g;
    /* pseudo element */

    var writingptn = /[svh]\w+-[tblr]{2}/;
    /* match *gradient property */

    var supportsptn = /\(\s*(.*)\s*\)/g;
    /* match supports (groups) */

    var propertyptn = /([\s\S]*?);/g;
    /* match properties leading semicolon */

    var selfptn = /-self|flex-/g;
    /* match flex- and -self in align-self: flex-*; */

    var pseudofmt = /[^]*?(:[rp][el]a[\w-]+)[^]*/;
    /* match tail whitspace */

    var dimensionptn = /stretch|:\s*\w+\-(?:conte|avail)/;
    /* match max/min/fit-content, fill-available */

    var imgsrcptn = /([^-])(image-set\()/;
    /* vendors */

    var webkit = '-webkit-';
    var moz = '-moz-';
    var ms = '-ms-';
    /* character codes */

    var SEMICOLON = 59;
    /* ; */

    var CLOSEBRACES = 125;
    /* } */

    var OPENBRACES = 123;
    /* { */

    var OPENPARENTHESES = 40;
    /* ( */

    var CLOSEPARENTHESES = 41;
    /* ) */

    var OPENBRACKET = 91;
    /* [ */

    var CLOSEBRACKET = 93;
    /* ] */

    var NEWLINE = 10;
    /* \n */

    var CARRIAGE = 13;
    /* \r */

    var TAB = 9;
    /* \t */

    var AT = 64;
    /* @ */

    var SPACE = 32;
    /*   */

    var AND = 38;
    /* & */

    var DASH = 45;
    /* - */

    var UNDERSCORE = 95;
    /* _ */

    var STAR = 42;
    /* * */

    var COMMA = 44;
    /* , */

    var COLON = 58;
    /* : */

    var SINGLEQUOTE = 39;
    /* ' */

    var DOUBLEQUOTE = 34;
    /* " */

    var FOWARDSLASH = 47;
    /* / */

    var GREATERTHAN = 62;
    /* > */

    var PLUS = 43;
    /* + */

    var TILDE = 126;
    /* ~ */

    var NULL = 0;
    /* \0 */

    var FORMFEED = 12;
    /* \f */

    var VERTICALTAB = 11;
    /* \v */

    /* special identifiers */

    var KEYFRAME = 107;
    /* k */

    var MEDIA = 109;
    /* m */

    var SUPPORTS = 115;
    /* s */

    var PLACEHOLDER = 112;
    /* p */

    var READONLY = 111;
    /* o */

    var IMPORT = 105;
    /* <at>i */

    var CHARSET = 99;
    /* <at>c */

    var DOCUMENT = 100;
    /* <at>d */

    var PAGE = 112;
    /* <at>p */

    var column = 1;
    /* current column */

    var line = 1;
    /* current line numebr */

    var pattern = 0;
    /* :pattern */

    var cascade = 1;
    /* #id h1 h2 vs h1#id h2#id  */

    var prefix = 1;
    /* vendor prefix */

    var escape = 1;
    /* escape :global() pattern */

    var compress = 0;
    /* compress output */

    var semicolon = 0;
    /* no/semicolon option */

    var preserve = 0;
    /* preserve empty selectors */

    /* empty reference */

    var array = [];
    /* plugins */

    var plugins = [];
    var plugged = 0;
    var should = null;
    /* plugin context */

    var POSTS = -2;
    var PREPS = -1;
    var UNKWN = 0;
    var PROPS = 1;
    var BLCKS = 2;
    var ATRUL = 3;
    /* plugin newline context */

    var unkwn = 0;
    /* keyframe animation */

    var keyed = 1;
    var key = '';
    /* selector namespace */

    var nscopealt = '';
    var nscope = '';
    /**
     * Compile
     *
     * @param {Array<string>} parent
     * @param {Array<string>} current
     * @param {string} body
     * @param {number} id
     * @param {number} depth
     * @return {string}
     */

    function compile(parent, current, body, id, depth) {
      var bracket = 0;
      /* brackets [] */

      var comment = 0;
      /* comments /* // or /* */

      var parentheses = 0;
      /* functions () */

      var quote = 0;
      /* quotes '', "" */

      var first = 0;
      /* first character code */

      var second = 0;
      /* second character code */

      var code = 0;
      /* current character code */

      var tail = 0;
      /* previous character code */

      var trail = 0;
      /* character before previous code */

      var peak = 0;
      /* previous non-whitespace code */

      var counter = 0;
      /* count sequence termination */

      var context = 0;
      /* track current context */

      var atrule = 0;
      /* track @at-rule context */

      var pseudo = 0;
      /* track pseudo token index */

      var caret = 0;
      /* current character index */

      var format = 0;
      /* control character formating context */

      var insert = 0;
      /* auto semicolon insertion */

      var invert = 0;
      /* inverted selector pattern */

      var length = 0;
      /* generic length address */

      var eof = body.length;
      /* end of file(length) */

      var eol = eof - 1;
      /* end of file(characters) */

      var _char = '';
      /* current character */

      var chars = '';
      /* current buffer of characters */

      var child = '';
      /* next buffer of characters */

      var out = '';
      /* compiled body */

      var children = '';
      /* compiled children */

      var flat = '';
      /* compiled leafs */

      var selector;
      /* generic selector address */

      var result;
      /* generic address */
      // ...build body

      while (caret < eof) {
        code = body.charCodeAt(caret); // eof varient

        if (caret === eol) {
          // last character + noop context, add synthetic padding for noop context to terminate
          if (comment + quote + parentheses + bracket !== 0) {
            if (comment !== 0) {
              code = comment === FOWARDSLASH ? NEWLINE : FOWARDSLASH;
            }

            quote = parentheses = bracket = 0;
            eof++;
            eol++;
          }
        }

        if (comment + quote + parentheses + bracket === 0) {
          // eof varient
          if (caret === eol) {
            if (format > 0) {
              chars = chars.replace(formatptn, '');
            }

            if (chars.trim().length > 0) {
              switch (code) {
                case SPACE:
                case TAB:
                case SEMICOLON:
                case CARRIAGE:
                case NEWLINE:
                  {
                    break;
                  }

                default:
                  {
                    chars += body.charAt(caret);
                  }
              }

              code = SEMICOLON;
            }
          } // auto semicolon insertion


          if (insert === 1) {
            switch (code) {
              // false flags
              case OPENBRACES:
              case CLOSEBRACES:
              case SEMICOLON:
              case DOUBLEQUOTE:
              case SINGLEQUOTE:
              case OPENPARENTHESES:
              case CLOSEPARENTHESES:
              case COMMA:
                {
                  insert = 0;
                }
              // ignore

              case TAB:
              case CARRIAGE:
              case NEWLINE:
              case SPACE:
                {
                  break;
                }
              // valid

              default:
                {
                  insert = 0;
                  length = caret;
                  first = code;
                  caret--;
                  code = SEMICOLON;

                  while (length < eof) {
                    switch (body.charCodeAt(length++)) {
                      case NEWLINE:
                      case CARRIAGE:
                      case SEMICOLON:
                        {
                          ++caret;
                          code = first;
                          length = eof;
                          break;
                        }

                      case COLON:
                        {
                          if (format > 0) {
                            ++caret;
                            code = first;
                          }
                        }

                      case OPENBRACES:
                        {
                          length = eof;
                        }
                    }
                  }
                }
            }
          } // token varient


          switch (code) {
            case OPENBRACES:
              {
                chars = chars.trim();
                first = chars.charCodeAt(0);
                counter = 1;
                length = ++caret;

                while (caret < eof) {
                  switch (code = body.charCodeAt(caret)) {
                    case OPENBRACES:
                      {
                        counter++;
                        break;
                      }

                    case CLOSEBRACES:
                      {
                        counter--;
                        break;
                      }

                    case FOWARDSLASH:
                      {
                        switch (second = body.charCodeAt(caret + 1)) {
                          // /*, //
                          case STAR:
                          case FOWARDSLASH:
                            {
                              caret = delimited(second, caret, eol, body);
                            }
                        }

                        break;
                      }
                    // given "[" === 91 & "]" === 93 hence forth 91 + 1 + 1 === 93

                    case OPENBRACKET:
                      {
                        code++;
                      }
                    // given "(" === 40 & ")" === 41 hence forth 40 + 1 === 41

                    case OPENPARENTHESES:
                      {
                        code++;
                      }
                    // quote tail delimiter is identical to the head delimiter hence noop,
                    // fallthrough clauses have been shifted to the correct tail delimiter

                    case DOUBLEQUOTE:
                    case SINGLEQUOTE:
                      {
                        while (caret++ < eol) {
                          if (body.charCodeAt(caret) === code) {
                            break;
                          }
                        }
                      }
                  }

                  if (counter === 0) {
                    break;
                  }

                  caret++;
                }

                child = body.substring(length, caret);

                if (first === NULL) {
                  first = (chars = chars.replace(nullptn, '').trim()).charCodeAt(0);
                }

                switch (first) {
                  // @at-rule
                  case AT:
                    {
                      if (format > 0) {
                        chars = chars.replace(formatptn, '');
                      }

                      second = chars.charCodeAt(1);

                      switch (second) {
                        case DOCUMENT:
                        case MEDIA:
                        case SUPPORTS:
                        case DASH:
                          {
                            selector = current;
                            break;
                          }

                        default:
                          {
                            selector = array;
                          }
                      }

                      child = compile(current, selector, child, second, depth + 1);
                      length = child.length; // preserve empty @at-rule

                      if (preserve > 0 && length === 0) {
                        length = chars.length;
                      } // execute plugins, @at-rule context


                      if (plugged > 0) {
                        selector = select(array, chars, invert);
                        result = proxy(ATRUL, child, selector, current, line, column, length, second, depth, id);
                        chars = selector.join('');

                        if (result !== void 0) {
                          if ((length = (child = result.trim()).length) === 0) {
                            second = 0;
                            child = '';
                          }
                        }
                      }

                      if (length > 0) {
                        switch (second) {
                          case SUPPORTS:
                            {
                              chars = chars.replace(supportsptn, supports);
                            }

                          case DOCUMENT:
                          case MEDIA:
                          case DASH:
                            {
                              child = chars + '{' + child + '}';
                              break;
                            }

                          case KEYFRAME:
                            {
                              chars = chars.replace(keyframeptn, '$1 $2' + (keyed > 0 ? key : ''));
                              child = chars + '{' + child + '}';

                              if (prefix === 1 || prefix === 2 && vendor('@' + child, 3)) {
                                child = '@' + webkit + child + '@' + child;
                              } else {
                                child = '@' + child;
                              }

                              break;
                            }

                          default:
                            {
                              child = chars + child;

                              if (id === PAGE) {
                                child = (out += child, '');
                              }
                            }
                        }
                      } else {
                        child = '';
                      }

                      break;
                    }
                  // selector

                  default:
                    {
                      child = compile(current, select(current, chars, invert), child, id, depth + 1);
                    }
                }

                children += child; // reset

                context = 0;
                insert = 0;
                pseudo = 0;
                format = 0;
                invert = 0;
                atrule = 0;
                chars = '';
                child = '';
                code = body.charCodeAt(++caret);
                break;
              }

            case CLOSEBRACES:
            case SEMICOLON:
              {
                chars = (format > 0 ? chars.replace(formatptn, '') : chars).trim();

                if ((length = chars.length) > 1) {
                  // monkey-patch missing colon
                  if (pseudo === 0) {
                    first = chars.charCodeAt(0); // first character is a letter or dash, buffer has a space character

                    if (first === DASH || first > 96 && first < 123) {
                      length = (chars = chars.replace(' ', ':')).length;
                    }
                  } // execute plugins, property context


                  if (plugged > 0) {
                    if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id, depth, id)) !== void 0) {
                      if ((length = (chars = result.trim()).length) === 0) {
                        chars = '\0\0';
                      }
                    }
                  }

                  first = chars.charCodeAt(0);
                  second = chars.charCodeAt(1);

                  switch (first) {
                    case NULL:
                      {
                        break;
                      }

                    case AT:
                      {
                        if (second === IMPORT || second === CHARSET) {
                          flat += chars + body.charAt(caret);
                          break;
                        }
                      }

                    default:
                      {
                        if (chars.charCodeAt(length - 1) === COLON) {
                          break;
                        }

                        out += property(chars, first, second, chars.charCodeAt(2));
                      }
                  }
                } // reset


                context = 0;
                insert = 0;
                pseudo = 0;
                format = 0;
                invert = 0;
                chars = '';
                code = body.charCodeAt(++caret);
                break;
              }
          }
        } // parse characters


        switch (code) {
          case CARRIAGE:
          case NEWLINE:
            {
              // auto insert semicolon
              if (comment + quote + parentheses + bracket + semicolon === 0) {
                // valid non-whitespace characters that
                // may precede a newline
                switch (peak) {
                  case CLOSEPARENTHESES:
                  case SINGLEQUOTE:
                  case DOUBLEQUOTE:
                  case AT:
                  case TILDE:
                  case GREATERTHAN:
                  case STAR:
                  case PLUS:
                  case FOWARDSLASH:
                  case DASH:
                  case COLON:
                  case COMMA:
                  case SEMICOLON:
                  case OPENBRACES:
                  case CLOSEBRACES:
                    {
                      break;
                    }

                  default:
                    {
                      // current buffer has a colon
                      if (pseudo > 0) {
                        insert = 1;
                      }
                    }
                }
              } // terminate line comment


              if (comment === FOWARDSLASH) {
                comment = 0;
              } else if (cascade + context === 0 && id !== KEYFRAME && chars.length > 0) {
                format = 1;
                chars += '\0';
              } // execute plugins, newline context


              if (plugged * unkwn > 0) {
                proxy(UNKWN, chars, current, parent, line, column, out.length, id, depth, id);
              } // next line, reset column position


              column = 1;
              line++;
              break;
            }

          case SEMICOLON:
          case CLOSEBRACES:
            {
              if (comment + quote + parentheses + bracket === 0) {
                column++;
                break;
              }
            }

          default:
            {
              // increment column position
              column++; // current character

              _char = body.charAt(caret); // remove comments, escape functions, strings, attributes and prepare selectors

              switch (code) {
                case TAB:
                case SPACE:
                  {
                    if (quote + bracket + comment === 0) {
                      switch (tail) {
                        case COMMA:
                        case COLON:
                        case TAB:
                        case SPACE:
                          {
                            _char = '';
                            break;
                          }

                        default:
                          {
                            if (code !== SPACE) {
                              _char = ' ';
                            }
                          }
                      }
                    }

                    break;
                  }
                // escape breaking control characters

                case NULL:
                  {
                    _char = '\\0';
                    break;
                  }

                case FORMFEED:
                  {
                    _char = '\\f';
                    break;
                  }

                case VERTICALTAB:
                  {
                    _char = '\\v';
                    break;
                  }
                // &

                case AND:
                  {
                    // inverted selector pattern i.e html &
                    if (quote + comment + bracket === 0 && cascade > 0) {
                      invert = 1;
                      format = 1;
                      _char = '\f' + _char;
                    }

                    break;
                  }
                // ::p<l>aceholder, l
                // :read-on<l>y, l

                case 108:
                  {
                    if (quote + comment + bracket + pattern === 0 && pseudo > 0) {
                      switch (caret - pseudo) {
                        // ::placeholder
                        case 2:
                          {
                            if (tail === PLACEHOLDER && body.charCodeAt(caret - 3) === COLON) {
                              pattern = tail;
                            }
                          }
                        // :read-only

                        case 8:
                          {
                            if (trail === READONLY) {
                              pattern = trail;
                            }
                          }
                      }
                    }

                    break;
                  }
                // :<pattern>

                case COLON:
                  {
                    if (quote + comment + bracket === 0) {
                      pseudo = caret;
                    }

                    break;
                  }
                // selectors

                case COMMA:
                  {
                    if (comment + parentheses + quote + bracket === 0) {
                      format = 1;
                      _char += '\r';
                    }

                    break;
                  }
                // quotes

                case DOUBLEQUOTE:
                case SINGLEQUOTE:
                  {
                    if (comment === 0) {
                      quote = quote === code ? 0 : quote === 0 ? code : quote;
                    }

                    break;
                  }
                // attributes

                case OPENBRACKET:
                  {
                    if (quote + comment + parentheses === 0) {
                      bracket++;
                    }

                    break;
                  }

                case CLOSEBRACKET:
                  {
                    if (quote + comment + parentheses === 0) {
                      bracket--;
                    }

                    break;
                  }
                // functions

                case CLOSEPARENTHESES:
                  {
                    if (quote + comment + bracket === 0) {
                      parentheses--;
                    }

                    break;
                  }

                case OPENPARENTHESES:
                  {
                    if (quote + comment + bracket === 0) {
                      if (context === 0) {
                        switch (tail * 2 + trail * 3) {
                          // :matches
                          case 533:
                            {
                              break;
                            }
                          // :global, :not, :nth-child etc...

                          default:
                            {
                              counter = 0;
                              context = 1;
                            }
                        }
                      }

                      parentheses++;
                    }

                    break;
                  }

                case AT:
                  {
                    if (comment + parentheses + quote + bracket + pseudo + atrule === 0) {
                      atrule = 1;
                    }

                    break;
                  }
                // block/line comments

                case STAR:
                case FOWARDSLASH:
                  {
                    if (quote + bracket + parentheses > 0) {
                      break;
                    }

                    switch (comment) {
                      // initialize line/block comment context
                      case 0:
                        {
                          switch (code * 2 + body.charCodeAt(caret + 1) * 3) {
                            // //
                            case 235:
                              {
                                comment = FOWARDSLASH;
                                break;
                              }
                            // /*

                            case 220:
                              {
                                length = caret;
                                comment = STAR;
                                break;
                              }
                          }

                          break;
                        }
                      // end block comment context

                      case STAR:
                        {
                          if (code === FOWARDSLASH && tail === STAR && length + 2 !== caret) {
                            // /*<!> ... */, !
                            if (body.charCodeAt(length + 2) === 33) {
                              out += body.substring(length, caret + 1);
                            }

                            _char = '';
                            comment = 0;
                          }
                        }
                    }
                  }
              } // ignore comment blocks


              if (comment === 0) {
                // aggressive isolation mode, divide each individual selector
                // including selectors in :not function but excluding selectors in :global function
                if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) {
                  switch (code) {
                    case COMMA:
                    case TILDE:
                    case GREATERTHAN:
                    case PLUS:
                    case CLOSEPARENTHESES:
                    case OPENPARENTHESES:
                      {
                        if (context === 0) {
                          // outside of an isolated context i.e nth-child(<...>)
                          switch (tail) {
                            case TAB:
                            case SPACE:
                            case NEWLINE:
                            case CARRIAGE:
                              {
                                _char = _char + '\0';
                                break;
                              }

                            default:
                              {
                                _char = '\0' + _char + (code === COMMA ? '' : '\0');
                              }
                          }

                          format = 1;
                        } else {
                          // within an isolated context, sleep untill it's terminated
                          switch (code) {
                            case OPENPARENTHESES:
                              {
                                // :globa<l>(
                                if (pseudo + 7 === caret && tail === 108) {
                                  pseudo = 0;
                                }

                                context = ++counter;
                                break;
                              }

                            case CLOSEPARENTHESES:
                              {
                                if ((context = --counter) === 0) {
                                  format = 1;
                                  _char += '\0';
                                }

                                break;
                              }
                          }
                        }

                        break;
                      }

                    case TAB:
                    case SPACE:
                      {
                        switch (tail) {
                          case NULL:
                          case OPENBRACES:
                          case CLOSEBRACES:
                          case SEMICOLON:
                          case COMMA:
                          case FORMFEED:
                          case TAB:
                          case SPACE:
                          case NEWLINE:
                          case CARRIAGE:
                            {
                              break;
                            }

                          default:
                            {
                              // ignore in isolated contexts
                              if (context === 0) {
                                format = 1;
                                _char += '\0';
                              }
                            }
                        }
                      }
                  }
                } // concat buffer of characters


                chars += _char; // previous non-whitespace character code

                if (code !== SPACE && code !== TAB) {
                  peak = code;
                }
              }
            }
        } // tail character codes


        trail = tail;
        tail = code; // visit every character

        caret++;
      }

      length = out.length; // preserve empty selector

      if (preserve > 0) {
        if (length === 0 && children.length === 0 && current[0].length === 0 === false) {
          if (id !== MEDIA || current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0]) {
            length = current.join(',').length + 2;
          }
        }
      }

      if (length > 0) {
        // cascade isolation mode?
        selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current; // execute plugins, block context

        if (plugged > 0) {
          result = proxy(BLCKS, out, selector, parent, line, column, length, id, depth, id);

          if (result !== void 0 && (out = result).length === 0) {
            return flat + out + children;
          }
        }

        out = selector.join(',') + '{' + out + '}';

        if (prefix * pattern !== 0) {
          if (prefix === 2 && !vendor(out, 2)) pattern = 0;

          switch (pattern) {
            // ::read-only
            case READONLY:
              {
                out = out.replace(readonlyptn, ':' + moz + '$1') + out;
                break;
              }
            // ::placeholder

            case PLACEHOLDER:
              {
                out = out.replace(plcholdrptn, '::' + webkit + 'input-$1') + out.replace(plcholdrptn, '::' + moz + '$1') + out.replace(plcholdrptn, ':' + ms + 'input-$1') + out;
                break;
              }
          }

          pattern = 0;
        }
      }

      return flat + out + children;
    }
    /**
     * Select
     *
     * @param {Array<string>} parent
     * @param {string} current
     * @param {number} invert
     * @return {Array<string>}
     */


    function select(parent, current, invert) {
      var selectors = current.trim().split(selectorptn);
      var out = selectors;
      var length = selectors.length;
      var l = parent.length;

      switch (l) {
        // 0-1 parent selectors
        case 0:
        case 1:
          {
            for (var i = 0, selector = l === 0 ? '' : parent[0] + ' '; i < length; ++i) {
              out[i] = scope(selector, out[i], invert, l).trim();
            }

            break;
          }
        // >2 parent selectors, nested

        default:
          {
            for (var i = 0, j = 0, out = []; i < length; ++i) {
              for (var k = 0; k < l; ++k) {
                out[j++] = scope(parent[k] + ' ', selectors[i], invert, l).trim();
              }
            }
          }
      }

      return out;
    }
    /**
     * Scope
     *
     * @param {string} parent
     * @param {string} current
     * @param {number} invert
     * @param {number} level
     * @return {string}
     */


    function scope(parent, current, invert, level) {
      var selector = current;
      var code = selector.charCodeAt(0); // trim leading whitespace

      if (code < 33) {
        code = (selector = selector.trim()).charCodeAt(0);
      }

      switch (code) {
        // &
        case AND:
          {
            switch (cascade + level) {
              case 0:
              case 1:
                {
                  if (parent.trim().length === 0) {
                    break;
                  }
                }

              default:
                {
                  return selector.replace(andptn, '$1' + parent.trim());
                }
            }

            break;
          }
        // :

        case COLON:
          {
            switch (selector.charCodeAt(1)) {
              // g in :global
              case 103:
                {
                  if (escape > 0 && cascade > 0) {
                    return selector.replace(escapeptn, '$1').replace(andptn, '$1' + nscope);
                  }

                  break;
                }

              default:
                {
                  // :hover
                  return parent.trim() + selector.replace(andptn, '$1' + parent.trim());
                }
            }
          }

        default:
          {
            // html &
            if (invert * cascade > 0 && selector.indexOf('\f') > 0) {
              return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? '' : '$1') + parent.trim());
            }
          }
      }

      return parent + selector;
    }
    /**
     * Property
     *
     * @param {string} input
     * @param {number} first
     * @param {number} second
     * @param {number} third
     * @return {string}
     */


    function property(input, first, second, third) {
      var index = 0;
      var out = input + ';';
      var hash = first * 2 + second * 3 + third * 4;
      var cache; // animation: a, n, i characters

      if (hash === 944) {
        return animation(out);
      } else if (prefix === 0 || prefix === 2 && !vendor(out, 1)) {
        return out;
      } // vendor prefix


      switch (hash) {
        // text-decoration/text-size-adjust/text-shadow/text-align/text-transform: t, e, x
        case 1015:
          {
            // text-shadow/text-align/text-transform, a
            return out.charCodeAt(10) === 97 ? webkit + out + out : out;
          }
        // filter/fill f, i, l

        case 951:
          {
            // filter, t
            return out.charCodeAt(3) === 116 ? webkit + out + out : out;
          }
        // color/column, c, o, l

        case 963:
          {
            // column, n
            return out.charCodeAt(5) === 110 ? webkit + out + out : out;
          }
        // box-decoration-break, b, o, x

        case 1009:
          {
            if (out.charCodeAt(4) !== 100) {
              break;
            }
          }
        // mask, m, a, s
        // clip-path, c, l, i

        case 969:
        case 942:
          {
            return webkit + out + out;
          }
        // appearance: a, p, p

        case 978:
          {
            return webkit + out + moz + out + out;
          }
        // hyphens: h, y, p
        // user-select: u, s, e

        case 1019:
        case 983:
          {
            return webkit + out + moz + out + ms + out + out;
          }
        // background/backface-visibility, b, a, c

        case 883:
          {
            // backface-visibility, -
            if (out.charCodeAt(8) === DASH) {
              return webkit + out + out;
            } // image-set(...)


            if (out.indexOf('image-set(', 11) > 0) {
              return out.replace(imgsrcptn, '$1' + webkit + '$2') + out;
            }

            return out;
          }
        // flex: f, l, e

        case 932:
          {
            if (out.charCodeAt(4) === DASH) {
              switch (out.charCodeAt(5)) {
                // flex-grow, g
                case 103:
                  {
                    return webkit + 'box-' + out.replace('-grow', '') + webkit + out + ms + out.replace('grow', 'positive') + out;
                  }
                // flex-shrink, s

                case 115:
                  {
                    return webkit + out + ms + out.replace('shrink', 'negative') + out;
                  }
                // flex-basis, b

                case 98:
                  {
                    return webkit + out + ms + out.replace('basis', 'preferred-size') + out;
                  }
              }
            }

            return webkit + out + ms + out + out;
          }
        // order: o, r, d

        case 964:
          {
            return webkit + out + ms + 'flex' + '-' + out + out;
          }
        // justify-items/justify-content, j, u, s

        case 1023:
          {
            // justify-content, c
            if (out.charCodeAt(8) !== 99) {
              break;
            }

            cache = out.substring(out.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
            return webkit + 'box-pack' + cache + webkit + out + ms + 'flex-pack' + cache + out;
          }
        // cursor, c, u, r

        case 1005:
          {
            return cursorptn.test(out) ? out.replace(colonptn, ':' + webkit) + out.replace(colonptn, ':' + moz) + out : out;
          }
        // writing-mode, w, r, i

        case 1000:
          {
            cache = out.substring(13).trim();
            index = cache.indexOf('-') + 1;

            switch (cache.charCodeAt(0) + cache.charCodeAt(index)) {
              // vertical-lr
              case 226:
                {
                  cache = out.replace(writingptn, 'tb');
                  break;
                }
              // vertical-rl

              case 232:
                {
                  cache = out.replace(writingptn, 'tb-rl');
                  break;
                }
              // horizontal-tb

              case 220:
                {
                  cache = out.replace(writingptn, 'lr');
                  break;
                }

              default:
                {
                  return out;
                }
            }

            return webkit + out + ms + cache + out;
          }
        // position: sticky

        case 1017:
          {
            if (out.indexOf('sticky', 9) === -1) {
              return out;
            }
          }
        // display(flex/inline-flex/inline-box): d, i, s

        case 975:
          {
            index = (out = input).length - 10;
            cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(':', 7) + 1).trim();

            switch (hash = cache.charCodeAt(0) + (cache.charCodeAt(7) | 0)) {
              // inline-
              case 203:
                {
                  // inline-box
                  if (cache.charCodeAt(8) < 111) {
                    break;
                  }
                }
              // inline-box/sticky

              case 115:
                {
                  out = out.replace(cache, webkit + cache) + ';' + out;
                  break;
                }
              // inline-flex
              // flex

              case 207:
              case 102:
                {
                  out = out.replace(cache, webkit + (hash > 102 ? 'inline-' : '') + 'box') + ';' + out.replace(cache, webkit + cache) + ';' + out.replace(cache, ms + cache + 'box') + ';' + out;
                }
            }

            return out + ';';
          }
        // align-items, align-center, align-self: a, l, i, -

        case 938:
          {
            if (out.charCodeAt(5) === DASH) {
              switch (out.charCodeAt(6)) {
                // align-items, i
                case 105:
                  {
                    cache = out.replace('-items', '');
                    return webkit + out + webkit + 'box-' + cache + ms + 'flex-' + cache + out;
                  }
                // align-self, s

                case 115:
                  {
                    return webkit + out + ms + 'flex-item-' + out.replace(selfptn, '') + out;
                  }
                // align-content

                default:
                  {
                    return webkit + out + ms + 'flex-line-pack' + out.replace('align-content', '').replace(selfptn, '') + out;
                  }
              }
            }

            break;
          }
        // min/max

        case 973:
        case 989:
          {
            // min-/max- height/width/block-size/inline-size
            if (out.charCodeAt(3) !== DASH || out.charCodeAt(4) === 122) {
              break;
            }
          }
        // height/width: min-content / width: max-content

        case 931:
        case 953:
          {
            if (dimensionptn.test(input) === true) {
              // stretch
              if ((cache = input.substring(input.indexOf(':') + 1)).charCodeAt(0) === 115) return property(input.replace('stretch', 'fill-available'), first, second, third).replace(':fill-available', ':stretch');else return out.replace(cache, webkit + cache) + out.replace(cache, moz + cache.replace('fill-', '')) + out;
            }

            break;
          }
        // transform, transition: t, r, a

        case 962:
          {
            out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : '') + out; // transitions

            if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf('transform', 10) > 0) {
              return out.substring(0, out.indexOf(';', 27) + 1).replace(transformptn, '$1' + webkit + '$2') + out;
            }

            break;
          }
      }

      return out;
    }
    /**
     * Vendor
     *
     * @param {string} content
     * @param {number} context
     * @return {boolean}
     */


    function vendor(content, context) {
      var index = content.indexOf(context === 1 ? ':' : '{');
      var key = content.substring(0, context !== 3 ? index : 10);
      var value = content.substring(index + 1, content.length - 1);
      return should(context !== 2 ? key : key.replace(pseudofmt, '$1'), value, context);
    }
    /**
     * Supports
     *
     * @param {string} match
     * @param {string} group
     * @return {string}
     */


    function supports(match, group) {
      var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2));
      return out !== group + ';' ? out.replace(propertyptn, ' or ($1)').substring(4) : '(' + group + ')';
    }
    /**
     * Animation
     *
     * @param {string} input
     * @return {string}
     */


    function animation(input) {
      var length = input.length;
      var index = input.indexOf(':', 9) + 1;
      var declare = input.substring(0, index).trim();
      var out = input.substring(index, length - 1).trim();

      switch (input.charCodeAt(9) * keyed) {
        case 0:
          {
            break;
          }
        // animation-*, -

        case DASH:
          {
            // animation-name, n
            if (input.charCodeAt(10) !== 110) {
              break;
            }
          }
        // animation/animation-name

        default:
          {
            // split in case of multiple animations
            var list = out.split((out = '', animationptn));

            for (var i = 0, index = 0, length = list.length; i < length; index = 0, ++i) {
              var value = list[i];
              var items = value.split(propertiesptn);

              while (value = items[index]) {
                var peak = value.charCodeAt(0);

                if (keyed === 1 && ( // letters
                peak > AT && peak < 90 || peak > 96 && peak < 123 || peak === UNDERSCORE || // dash but not in sequence i.e --
                peak === DASH && value.charCodeAt(1) !== DASH)) {
                  // not a number/function
                  switch (isNaN(parseFloat(value)) + (value.indexOf('(') !== -1)) {
                    case 1:
                      {
                        switch (value) {
                          // not a valid reserved keyword
                          case 'infinite':
                          case 'alternate':
                          case 'backwards':
                          case 'running':
                          case 'normal':
                          case 'forwards':
                          case 'both':
                          case 'none':
                          case 'linear':
                          case 'ease':
                          case 'ease-in':
                          case 'ease-out':
                          case 'ease-in-out':
                          case 'paused':
                          case 'reverse':
                          case 'alternate-reverse':
                          case 'inherit':
                          case 'initial':
                          case 'unset':
                          case 'step-start':
                          case 'step-end':
                            {
                              break;
                            }

                          default:
                            {
                              value += key;
                            }
                        }
                      }
                  }
                }

                items[index++] = value;
              }

              out += (i === 0 ? '' : ',') + items.join(' ');
            }
          }
      }

      out = declare + out + ';';
      if (prefix === 1 || prefix === 2 && vendor(out, 1)) return webkit + out + out;
      return out;
    }
    /**
     * Isolate
     *
     * @param {Array<string>} current
     */


    function isolate(current) {
      for (var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i) {
        // split individual elements in a selector i.e h1 h2 === [h1, h2]
        var elements = current[i].split(elementptn);
        var out = '';

        for (var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j) {
          // empty element
          if ((size = (element = elements[j]).length) === 0 && l > 1) {
            continue;
          }

          tail = out.charCodeAt(out.length - 1);
          code = element.charCodeAt(0);
          padding = '';

          if (j !== 0) {
            // determine if we need padding
            switch (tail) {
              case STAR:
              case TILDE:
              case GREATERTHAN:
              case PLUS:
              case SPACE:
              case OPENPARENTHESES:
                {
                  break;
                }

              default:
                {
                  padding = ' ';
                }
            }
          }

          switch (code) {
            case AND:
              {
                element = padding + nscopealt;
              }

            case TILDE:
            case GREATERTHAN:
            case PLUS:
            case SPACE:
            case CLOSEPARENTHESES:
            case OPENPARENTHESES:
              {
                break;
              }

            case OPENBRACKET:
              {
                element = padding + element + nscopealt;
                break;
              }

            case COLON:
              {
                switch (element.charCodeAt(1) * 2 + element.charCodeAt(2) * 3) {
                  // :global
                  case 530:
                    {
                      if (escape > 0) {
                        element = padding + element.substring(8, size - 1);
                        break;
                      }
                    }
                  // :hover, :nth-child(), ...

                  default:
                    {
                      if (j < 1 || elements[j - 1].length < 1) {
                        element = padding + nscopealt + element;
                      }
                    }
                }

                break;
              }

            case COMMA:
              {
                padding = '';
              }

            default:
              {
                if (size > 1 && element.indexOf(':') > 0) {
                  element = padding + element.replace(pseudoptn, '$1' + nscopealt + '$2');
                } else {
                  element = padding + element + nscopealt;
                }
              }
          }

          out += element;
        }

        selector[i] = out.replace(formatptn, '').trim();
      }

      return selector;
    }
    /**
     * Proxy
     *
     * @param {number} context
     * @param {string} content
     * @param {Array<string>} selectors
     * @param {Array<string>} parents
     * @param {number} line
     * @param {number} column
     * @param {number} length
     * @param {number} id
     * @param {number} depth
     * @param {number} at
     * @return {(string|void|*)}
     */


    function proxy(context, content, selectors, parents, line, column, length, id, depth, at) {
      for (var i = 0, out = content, next; i < plugged; ++i) {
        switch (next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id, depth, at)) {
          case void 0:
          case false:
          case true:
          case null:
            {
              break;
            }

          default:
            {
              out = next;
            }
        }
      }

      if (out !== content) {
        return out;
      }
    }
    /**
     * @param {number} code
     * @param {number} index
     * @param {number} length
     * @param {string} body
     * @return {number}
     */


    function delimited(code, index, length, body) {
      for (var i = index + 1; i < length; ++i) {
        switch (body.charCodeAt(i)) {
          // /*
          case FOWARDSLASH:
            {
              if (code === STAR) {
                if (body.charCodeAt(i - 1) === STAR && index + 2 !== i) {
                  return i + 1;
                }
              }

              break;
            }
          // //

          case NEWLINE:
            {
              if (code === FOWARDSLASH) {
                return i + 1;
              }
            }
        }
      }

      return i;
    }
    /**
     * Minify
     *
     * @param {(string|*)} output
     * @return {string}
     */


    function minify(output) {
      return output.replace(formatptn, '').replace(beforeptn, '').replace(afterptn, '$1').replace(tailptn, '$1').replace(whiteptn, ' ');
    }
    /**
     * Use
     *
     * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
     */


    function use(plugin) {
      switch (plugin) {
        case void 0:
        case null:
          {
            plugged = plugins.length = 0;
            break;
          }

        default:
          {
            if (typeof plugin === 'function') {
              plugins[plugged++] = plugin;
            } else if (typeof plugin === 'object') {
              for (var i = 0, length = plugin.length; i < length; ++i) {
                use(plugin[i]);
              }
            } else {
              unkwn = !!plugin | 0;
            }
          }
      }

      return use;
    }
    /**
     * Set
     *
     * @param {*} options
     */


    function set(options) {
      for (var name in options) {
        var value = options[name];

        switch (name) {
          case 'keyframe':
            keyed = value | 0;
            break;

          case 'global':
            escape = value | 0;
            break;

          case 'cascade':
            cascade = value | 0;
            break;

          case 'compress':
            compress = value | 0;
            break;

          case 'semicolon':
            semicolon = value | 0;
            break;

          case 'preserve':
            preserve = value | 0;
            break;

          case 'prefix':
            should = null;

            if (!value) {
              prefix = 0;
            } else if (typeof value !== 'function') {
              prefix = 1;
            } else {
              prefix = 2;
              should = value;
            }

        }
      }

      return set;
    }
    /**
     * Stylis
     *
     * @param {string} selector
     * @param {string} input
     * @return {*}
     */


    function stylis(selector, input) {
      if (this !== void 0 && this.constructor === stylis) {
        return factory(selector);
      } // setup


      var ns = selector;
      var code = ns.charCodeAt(0); // trim leading whitespace

      if (code < 33) {
        code = (ns = ns.trim()).charCodeAt(0);
      } // keyframe/animation namespace


      if (keyed > 0) {
        key = ns.replace(invalidptn, code === OPENBRACKET ? '' : '-');
      } // reset, used to assert if a plugin is moneky-patching the return value


      code = 1; // cascade/isolate

      if (cascade === 1) {
        nscope = ns;
      } else {
        nscopealt = ns;
      }

      var selectors = [nscope];
      var result; // execute plugins, pre-process context

      if (plugged > 0) {
        result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0, 0, 0);

        if (result !== void 0 && typeof result === 'string') {
          input = result;
        }
      } // build


      var output = compile(array, selectors, input, 0, 0); // execute plugins, post-process context

      if (plugged > 0) {
        result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0, 0, 0); // bypass minification

        if (result !== void 0 && typeof (output = result) !== 'string') {
          code = 0;
        }
      } // reset


      key = '';
      nscope = '';
      nscopealt = '';
      pattern = 0;
      line = 1;
      column = 1;
      return compress * code === 0 ? output : minify(output);
    }

    stylis['use'] = use;
    stylis['set'] = set;

    if (options !== void 0) {
      set(options);
    }

    return stylis;
  });
});
var processor =
/*#__PURE__*/
new stylis({
  keyframe: false
});

function getProcessedRules(selector, cssRules) {
  return processor(selector.replace(":", "\\:").replace("/", "\\/"), cssRules);
}

function createHash(str) {
  var n = 0x5bd1e995;
  var l = str.length,
      h = l ^ l,
      i = 0,
      k;

  while (l >= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k = (k & 0xffff) * n + (((k >>> 16) * n & 0xffff) << 16);
    k ^= k >>> 24;
    k = (k & 0xffff) * n + (((k >>> 16) * n & 0xffff) << 16);
    h = (h & 0xffff) * n + (((h >>> 16) * n & 0xffff) << 16) ^ k;
    l -= 4;
    ++i;
  }

  switch (l) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  }

  h ^= h >>> 13;
  h = (h & 0xffff) * n + (((h >>> 16) * n & 0xffff) << 16);
  h ^= h >>> 15;
  return (h >>> 0).toString(36);
}

var keys = {
  PREFLIGHT: "preflight",
  GLOBAL: "global",
  KEYFRAMES: "keyframes",
  NORMALIZE: "normalize",
  UTILITIES: "utilities",
  CSS: "css"
};

function findInsertionIndex(index, array, low, high) {
  if (low === void 0) {
    low = 0;
  }

  if (high === void 0) {
    high = array.length - 1;
  }

  if (!array.length) {
    return 0;
  }

  while (low <= high) {
    var mid = low + (high - low >> 1);
    var value = array[mid].index;

    if (index < value) {
      high = mid - 1;
    } else if (index > value) {
      low = mid + 1;
    } else {
      return mid;
    }
  }

  return low;
}

function insertUtility(insertAtIndex, newUtility, utilities) {
  var newUtilities;

  if (insertAtIndex <= 0) {
    newUtilities = [newUtility].concat(utilities);
  } else if (insertAtIndex >= utilities.length) {
    newUtilities = [].concat(utilities, [newUtility]);
  } else {
    newUtilities = [].concat(utilities.slice(0, insertAtIndex), [newUtility], utilities.slice(insertAtIndex));
  }

  return newUtilities;
}

function createRegistry(fromRegistry) {
  if (fromRegistry === void 0) {
    fromRegistry = {};
  }

  var _fromRegistry = fromRegistry,
      _fromRegistry$preflig = _fromRegistry.preflight,
      preflight = _fromRegistry$preflig === void 0 ? [] : _fromRegistry$preflig,
      _fromRegistry$global = _fromRegistry.global,
      global = _fromRegistry$global === void 0 ? [] : _fromRegistry$global,
      _fromRegistry$keyfram = _fromRegistry.keyframes,
      keyframes = _fromRegistry$keyfram === void 0 ? [] : _fromRegistry$keyfram,
      _fromRegistry$normali = _fromRegistry.normalize,
      normalize = _fromRegistry$normali === void 0 ? [] : _fromRegistry$normali,
      _fromRegistry$utiliti = _fromRegistry.utilities,
      utilities = _fromRegistry$utiliti === void 0 ? [] : _fromRegistry$utiliti,
      _fromRegistry$css = _fromRegistry.css,
      css = _fromRegistry$css === void 0 ? [] : _fromRegistry$css;
  var _registry = {
    preflight: preflight,
    global: global,
    keyframes: keyframes,
    normalize: normalize,
    utilities: utilities,
    css: css
  };
  var _listeners = [];

  function broadcast(key, entry, index) {
    _listeners.forEach(function (l) {
      return l(key, entry, index);
    });
  }

  function addEntry(key, entry) {
    if (key === keys.UTILITIES) {
      addUtilityEntry(entry);
      return;
    }

    var id = entry.id; // See if entry already exists

    var existingEntry = _registry[key].find(function (u) {
      return u.id === id;
    }); // No entry? add it in


    if (!existingEntry) {
      _registry[key].push(entry);

      broadcast(key, entry);
    }
  }

  function addUtilityEntry(entry) {
    var id = entry.id,
        index = entry.index; // See if entry already exists by index

    var existingEntryIndex = _registry[keys.UTILITIES].map(function (u) {
      return u.index;
    }).indexOf(index); // If there is one, check the id hash


    if (existingEntryIndex > -1) {
      var existingEntry = _registry[keys.UTILITIES][existingEntryIndex];

      if (existingEntry.id !== id) {
        // This is a different hash, assume the content has changed and update that local index
        _registry[keys.UTILITIES][existingEntryIndex] = entry;
        broadcast(keys.UTILITIES, entry, existingEntryIndex);
      }
    } else {
      // We couldn't find a global index, so assume this is a new value that needs to be inserted at the right place
      var newIndex = findInsertionIndex(index, _registry[keys.UTILITIES]);
      _registry[keys.UTILITIES] = insertUtility(newIndex, entry, _registry[keys.UTILITIES]);
      broadcast(keys.UTILITIES, entry, newIndex);
    }
  }

  return {
    add: function add(key, entry) {
      addEntry(key, entry);
    },
    addListener: function addListener(cb) {
      _listeners.push(cb);
    },
    getRegistry: function getRegistry() {
      return _registry;
    }
  };
}

var registry =
/*#__PURE__*/
function () {
  var instance;

  function create() {
    if (typeof window !== "undefined" && window.benefit) {
      return createRegistry(window.benefit);
    }

    return createRegistry();
  }

  return {
    getInstance: function getInstance() {
      if (!instance) {
        instance = create();
      }

      return instance;
    }
  };
}();

function isBrowser() {
  return typeof window !== "undefined" && typeof document !== "undefined";
}

function getMainContainer() {
  var container = document.getElementById("benefit-container");

  if (container) {
    return container;
  }

  var benefitContainer = document.createElement("div");
  benefitContainer.setAttribute("id", "benefit-container");
  document.body.prepend(benefitContainer);
  return benefitContainer;
}

function initializeContainer(label) {
  var name = "benefit-" + label;
  var container = document.getElementById(name);

  if (!container) {
    var newContainer = document.createElement("div");
    newContainer.setAttribute("id", name);
    getMainContainer().appendChild(newContainer);
  }
}

function initializeContainers() {
  if (isBrowser()) {
    initializeContainer("preflight");
    initializeContainer("global");
    initializeContainer("keyframes");
    initializeContainer("normalize");
    initializeContainer("utilities");
    initializeContainer("css");
  }
}

var isBrowser$1 = typeof window !== "undefined";

function createStyleTag(id, rules, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$label = _options.label,
      label = _options$label === void 0 ? "" : _options$label,
      _options$index = _options.index,
      index = _options$index === void 0 ? "" : _options$index;
  var styleTag = document.createElement("style");
  styleTag.setAttribute("id", id);
  styleTag.setAttribute("data-benefit" + (label ? "-" + label : ""), "");

  if (index) {
    styleTag.setAttribute("data-benefit-index", index);
  }

  styleTag.innerHTML = rules;
  return styleTag;
}

function insertStyle(type, entry, index) {
  if (isBrowser$1) {
    initializeContainers();

    if (type === "utilities") {
      var existingIndex = document.querySelector("[data-benefit-index='" + entry.index + "']");

      if (existingIndex) {
        existingIndex.id = entry.id;
        existingIndex.innerHTML = entry.rules;
      } else {
        var styleTag = createStyleTag(entry.id, entry.rules, {
          label: "utility",
          index: entry.index
        });
        var addedStyles = document.querySelectorAll("[data-benefit-utility]");
        var container = document.getElementById("benefit-utilities");

        if (container) {
          container.insertBefore(styleTag, addedStyles[index]);
        }
      }
    } else {
      if (!document.getElementById(entry.id)) {
        var _container = document.getElementById("benefit-" + type);

        if (_container) {
          _container.appendChild(createStyleTag(entry.id, entry.rules));
        }
      }
    }
  }
}

function generatePreflightStyles(selector) {
  var outerSelector = selector ? selector + " " : "";
  return "\n    " + (outerSelector ? outerSelector : "html") + " {\n      line-height: 1.15; \n      -webkit-text-size-adjust: 100%; \n    }\n    \n    " + outerSelector + "body {\n      margin: 0;\n    }\n    \n    " + outerSelector + "main {\n      display: block;\n    }\n    \n    " + outerSelector + "h1 {\n      font-size: 2em;\n      margin: 0.67em 0;\n    }\n    \n    " + outerSelector + "hr {\n      box-sizing: content-box; \n      height: 0; \n      overflow: visible; \n    }\n    \n    " + outerSelector + "pre {\n      font-family: monospace, monospace; \n      font-size: 1em; \n    }\n    \n    " + outerSelector + "a {\n      background-color: transparent;\n    }\n    \n    " + outerSelector + "abbr[title] {\n      border-bottom: none; \n      text-decoration: underline; \n      -webkit-text-decoration: underline dotted;\n              text-decoration: underline dotted; \n    }\n    \n    " + outerSelector + "b,\n    " + outerSelector + "strong {\n      font-weight: bolder;\n    }\n    \n    " + outerSelector + "code,\n    " + outerSelector + "kbd,\n    " + outerSelector + "samp {\n      font-family: monospace, monospace; \n      font-size: 1em; \n    }\n    \n    " + outerSelector + "small {\n      font-size: 80%;\n    }\n    \n    " + outerSelector + "sub,\n    " + outerSelector + "sup {\n      font-size: 75%;\n      line-height: 0;\n      position: relative;\n      vertical-align: baseline;\n    }\n    \n    " + outerSelector + "sub {\n      bottom: -0.25em;\n    }\n    \n    " + outerSelector + "sup {\n      top: -0.5em;\n    }\n    \n    " + outerSelector + "img {\n      border-style: none;\n    }\n    \n    " + outerSelector + "button,\n    " + outerSelector + "input,\n    " + outerSelector + "optgroup,\n    " + outerSelector + "select,\n    " + outerSelector + "textarea {\n      font-family: inherit; \n      font-size: 100%; \n      line-height: 1.15; \n      margin: 0; \n    }\n    \n    " + outerSelector + "button,\n    " + outerSelector + "input { \n      overflow: visible;\n    }\n    \n    " + outerSelector + "button,\n    " + outerSelector + "select { \n      text-transform: none;\n    }\n    \n    " + outerSelector + "button,\n    " + outerSelector + "[type=\"button\"],\n    " + outerSelector + "[type=\"reset\"],\n    " + outerSelector + "[type=\"submit\"] {\n      -webkit-appearance: button;\n    }\n    \n    " + outerSelector + "button::-moz-focus-inner,\n    " + outerSelector + "[type=\"button\"]::-moz-focus-inner,\n    " + outerSelector + "[type=\"reset\"]::-moz-focus-inner,\n    " + outerSelector + "[type=\"submit\"]::-moz-focus-inner {\n      border-style: none;\n      padding: 0;\n    }\n    \n    " + outerSelector + "button:-moz-focusring,\n    " + outerSelector + "[type=\"button\"]:-moz-focusring,\n    " + outerSelector + "[type=\"reset\"]:-moz-focusring,\n    " + outerSelector + "[type=\"submit\"]:-moz-focusring {\n      outline: 1px dotted ButtonText;\n    }\n    \n    " + outerSelector + "fieldset {\n      padding: 0.35em 0.75em 0.625em;\n    }\n    \n    " + outerSelector + "legend {\n      box-sizing: border-box; \n      color: inherit; \n      display: table; \n      max-width: 100%; \n      padding: 0; \n      white-space: normal; \n    }\n    \n    " + outerSelector + "progress {\n      vertical-align: baseline;\n    }\n    \n    " + outerSelector + "textarea {\n      overflow: auto;\n    }\n    \n    " + outerSelector + "[type=\"checkbox\"],\n    " + outerSelector + "[type=\"radio\"] {\n      box-sizing: border-box; \n      padding: 0; \n    }\n    \n    " + outerSelector + "[type=\"number\"]::-webkit-inner-spin-button,\n    " + outerSelector + "[type=\"number\"]::-webkit-outer-spin-button {\n      height: auto;\n    }\n    \n    " + outerSelector + "[type=\"search\"] {\n      -webkit-appearance: textfield; \n      outline-offset: -2px; \n    }\n    \n    " + outerSelector + "[type=\"search\"]::-webkit-search-decoration {\n      -webkit-appearance: none;\n    }\n    \n    " + outerSelector + "::-webkit-file-upload-button {\n      -webkit-appearance: button; \n      font: inherit; \n    }\n    \n    " + outerSelector + "details {\n      display: block;\n    }\n    \n    " + outerSelector + "summary {\n      display: list-item;\n    }\n    \n    " + outerSelector + "template {\n      display: none;\n    }\n    \n    " + outerSelector + "[hidden] {\n      display: none;\n    }\n    \n    " + (outerSelector ? outerSelector : "html") + " {\n      box-sizing: border-box; \n      font-family: sans-serif; \n    }\n    \n    " + outerSelector + "*,\n    " + outerSelector + "*::before,\n    " + outerSelector + "*::after {\n      box-sizing: inherit;\n    }\n    \n    " + outerSelector + "blockquote,\n    " + outerSelector + "dl,\n    " + outerSelector + "dd,\n    " + outerSelector + "h1,\n    " + outerSelector + "h2,\n    " + outerSelector + "h3,\n    " + outerSelector + "h4,\n    " + outerSelector + "h5,\n    " + outerSelector + "h6,\n    " + outerSelector + "figure,\n    " + outerSelector + "p,\n    " + outerSelector + "pre {\n      margin: 0;\n    }\n    \n    " + outerSelector + "button {\n      background: transparent;\n      padding: 0;\n    }\n    \n    " + outerSelector + "button:focus {\n      outline: 1px dotted;\n      outline: 5px auto -webkit-focus-ring-color;\n    }\n    \n    " + outerSelector + "fieldset {\n      margin: 0;\n      padding: 0;\n    }\n    \n    " + outerSelector + "ol,\n    " + outerSelector + "ul {\n      list-style: none;\n      margin: 0;\n      padding: 0;\n    }\n    \n    " + (outerSelector ? outerSelector : "html") + " {\n      font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\"; \n      line-height: 1.5; \n    }\n    \n    " + outerSelector + "*,\n    " + outerSelector + "*::before,\n    " + outerSelector + "*::after {\n      border-width: 0;\n      border-style: solid;\n      border-color: #e2e8f0;\n    }\n    \n    " + outerSelector + "img {\n      border-style: solid;\n    }\n    \n    " + outerSelector + "textarea {\n      resize: vertical;\n    }\n    \n    " + outerSelector + "input:-ms-input-placeholder,\n    " + outerSelector + "textarea:-ms-input-placeholder {\n      color: inherit;\n      opacity: 0.5;\n    }\n    \n    " + outerSelector + "input::-ms-input-placeholder,\n    " + outerSelector + "textarea::-ms-input-placeholder {\n      color: inherit;\n      opacity: 0.5;\n    }\n    \n    " + outerSelector + "input::placeholder,\n    " + outerSelector + "textarea::placeholder {\n      color: inherit;\n      opacity: 0.5;\n    }\n    \n    " + outerSelector + "button,\n    " + outerSelector + "[role=\"button\"] {\n      cursor: pointer;\n    }\n    \n    " + outerSelector + "table {\n      border-collapse: collapse;\n    }\n    \n    " + outerSelector + "h1,\n    " + outerSelector + "h2,\n    " + outerSelector + "h3,\n    " + outerSelector + "h4,\n    " + outerSelector + "h5,\n    " + outerSelector + "h6 {\n      font-size: inherit;\n      font-weight: inherit;\n    }\n    \n    " + outerSelector + "a {\n      color: inherit;\n      text-decoration: inherit;\n    }\n    \n    " + outerSelector + "button,\n    " + outerSelector + "input,\n    " + outerSelector + "optgroup,\n    " + outerSelector + "select,\n    " + outerSelector + "textarea {\n      padding: 0;\n      line-height: inherit;\n      color: inherit;\n    }\n    \n    " + outerSelector + "pre,\n    " + outerSelector + "code,\n    " + outerSelector + "kbd,\n    " + outerSelector + "samp {\n      font-family: Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n    }\n    \n    " + outerSelector + "img,\n    " + outerSelector + "svg,\n    " + outerSelector + "video,\n    " + outerSelector + "canvas,\n    " + outerSelector + "audio,\n    " + outerSelector + "iframe,\n    " + outerSelector + "embed,\n    " + outerSelector + "object {\n      display: block;\n      vertical-align: middle;\n    }\n    \n    " + outerSelector + "img,\n    " + outerSelector + "video {\n      max-width: 100%;\n      height: auto;\n    }\n  ";
}

var benefitRegistry =
/*#__PURE__*/
registry.getInstance();

function createBenefitFragment(category, styles, transformFn) {
  var hashId = "benefit-" + category + "-" + createHash(styles);
  var scope = "" + ([keys.CSS, keys.NORMALIZE].indexOf(category) > -1 ? "." : "") + hashId;
  var styleDeclarations = transformFn ? transformFn(styles, hashId) : styles;
  var processedStyles = getProcessedRules(scope, styleDeclarations);
  var registryEntry = {
    id: hashId,
    rules: processedStyles
  };
  benefitRegistry.add(category, registryEntry);
  return hashId;
}

function processCss(category, transformFn) {
  return function (strings) {
    for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      values[_key - 1] = arguments[_key];
    }

    var styles = strings.map(function (str, i) {
      return "" + str + (values[i] || "");
    }).join("");
    return createBenefitFragment(category, styles, transformFn);
  };
}

function injectPreflight(selector) {
  if (selector === void 0) {
    selector = "";
  }

  createBenefitFragment(keys.PREFLIGHT, generatePreflightStyles(selector), function (styles) {
    return "\n      :global() {\n        " + styles + "\n      }\n    ";
  });
}

var injectGlobal =
/*#__PURE__*/
processCss(keys.GLOBAL, function (styles) {
  return "\n    :global() {\n      " + styles + "\n    }\n  ";
});
var keyframes =
/*#__PURE__*/
processCss(keys.KEYFRAMES, function (styles, hashId) {
  return "\n    @keyframes " + hashId + " {\n      " + styles + "\n    }\n  ";
});
var injectNormalize =
/*#__PURE__*/
processCss(keys.NORMALIZE);
var css =
/*#__PURE__*/
processCss(keys.CSS);

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n        ", "\n      "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function createBenefit(configFn) {
  if (configFn === void 0) {
    configFn = function configFn() {
      return defaultConfig;
    };
  }

  var benefitRegistry = registry.getInstance();
  benefitRegistry.addListener(insertStyle);
  var config = configFn(defaultConfig);
  var _config$prefix = config.prefix,
      prefix = _config$prefix === void 0 ? "" : _config$prefix,
      _config$theme = config.theme,
      theme = _config$theme === void 0 ? {} : _config$theme,
      _config$normalize = config.normalize,
      normalize = _config$normalize === void 0 ? function () {
    return {};
  } : _config$normalize,
      _config$utilities = config.utilities,
      utilities = _config$utilities === void 0 ? [] : _config$utilities,
      _config$variants = config.variants,
      variants = _config$variants === void 0 ? [] : _config$variants,
      _config$apply = config.apply,
      apply = _config$apply === void 0 ? {} : _config$apply;
  var generatedUtilities = createUtilityMap(utilities, theme);
  var generatedVariants = createVariantMap(variants, generatedUtilities, theme);
  var prefixStr = prefix ? prefix + "-" : "";
  var normalizeDeclarations = normalize(theme);
  var shouldNormalize = Object.keys(normalizeDeclarations).length;
  var normalizeStyles = parseDeclarations(normalizeDeclarations).join("");
  var utilityClasses = {};
  Object.keys(generatedUtilities).forEach(function (key) {
    return utilityClasses["" + prefixStr + key] = generatedUtilities[key];
  });
  Object.keys(generatedVariants).forEach(function (key) {
    return utilityClasses["" + prefixStr + key] = generatedVariants[key];
  });

  var cssForUtility = function cssForUtility(className, isImportant) {
    if (isImportant === void 0) {
      isImportant = false;
    }

    return parseDeclarations(utilityClasses[className], isImportant).join(" ");
  }; // Not actually sorted, but we rely on the key order


  var sortedUtilityClasses = Object.keys(utilityClasses).reduce(function (map, key, i) {
    map[key] = i;
    return map;
  }, {});

  var getDeclarationsForClasses = function getDeclarationsForClasses(classNames, isImportant) {
    if (classNames === void 0) {
      classNames = "";
    }

    var activeApply = classNames.split(" ").filter(function (name) {
      return apply[name];
    });
    var classList = classNames.split(" ").map(function (className) {
      return className.trim();
    }).filter(Boolean).sort(function (a, b) {
      return sortedUtilityClasses[a] - sortedUtilityClasses[b];
    });

    for (var i = 0; i < activeApply.length; i++) {
      var applyClasses = apply[activeApply[i]];
      Array.prototype.push.apply(classList, applyClasses);
    }

    var ignoredClasses = [];
    var activeDeclarations = [];

    if (shouldNormalize) {
      var normalizeClass = injectNormalize(_templateObject(), normalizeStyles);
      classList.push(normalizeClass);
    }

    for (var _i = 0; _i < classList.length; _i++) {
      var className = classList[_i];

      if (utilityClasses[className]) {
        var rules = getProcessedRules("." + className, parseDeclarations(utilityClasses[className], isImportant).join(""));
        activeDeclarations.push({
          index: sortedUtilityClasses[className],
          id: "benefit-utility-" + createHash(rules),
          className: className,
          rules: rules
        });
      } else {
        ignoredClasses.push(className);
      }
    }

    return {
      declarations: activeDeclarations,
      ignoredClasses: ignoredClasses
    };
  };

  var styleWith = function styleWith(classNames, isImportant) {
    if (classNames === void 0) {
      classNames = "";
    }

    if (isImportant === void 0) {
      isImportant = false;
    }

    var _getDeclarationsForCl = getDeclarationsForClasses(classNames, isImportant),
        declarations = _getDeclarationsForCl.declarations,
        ignoredClasses = _getDeclarationsForCl.ignoredClasses;

    declarations.forEach(function (declaration) {
      benefitRegistry.add("utilities", declaration);
    });
    return declarations.map(function (d) {
      return d.className;
    }).concat(ignoredClasses).join(" ");
  };

  return {
    config: config,
    cssForUtility: cssForUtility,
    benefitRegistry: benefitRegistry,
    getDeclarationsForClasses: getDeclarationsForClasses,
    styleWith: styleWith,
    utilities: utilityClasses
  };
}

var _createBenefit =
/*#__PURE__*/
createBenefit(),
    config = _createBenefit.config,
    utilities$1 = _createBenefit.utilities,
    styleWith = _createBenefit.styleWith,
    benefitRegistry$1 = _createBenefit.benefitRegistry;

var ConfigContext =
/*#__PURE__*/
React.createContext({
  config: config,
  utilities: utilities$1,
  styleWith: styleWith,
  benefitRegistry: benefitRegistry$1
});

var ConfigProvider =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ConfigProvider, _React$Component);

  function ConfigProvider(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.updateConfig = function (newConfig) {
      var _createBenefit2 = createBenefit(newConfig),
          config = _createBenefit2.config,
          utilities = _createBenefit2.utilities,
          styleWith = _createBenefit2.styleWith,
          benefitRegistry = _createBenefit2.benefitRegistry;

      _this.setState({
        config: config,
        utilities: utilities,
        styleWith: styleWith,
        benefitRegistry: benefitRegistry
      });
    };

    var _createBenefit3 = createBenefit(props.config),
        config = _createBenefit3.config,
        utilities = _createBenefit3.utilities,
        styleWith = _createBenefit3.styleWith,
        benefitRegistry = _createBenefit3.benefitRegistry;

    _this.state = {
      config: config,
      utilities: utilities,
      styleWith: styleWith,
      benefitRegistry: benefitRegistry,
      updateConfig: _this.updateConfig
    };
    return _this;
  }

  var _proto = ConfigProvider.prototype;

  _proto.render = function render() {
    var children = this.props.children;
    return React.createElement(ConfigContext.Provider, {
      value: this.state
    }, children);
  };

  return ConfigProvider;
}(React.Component);

var ConfigConsumer = ConfigContext.Consumer;

function createContainer(label, styles) {
  return React.createElement("div", {
    id: "benefit-" + label
  }, styles.map(function (s) {
    var _extends2;

    return React.createElement("style", Object.assign({}, _extends({}, s.index && {
      "data-benefit-index": s.index
    }, (_extends2 = {}, _extends2["data-benefit-" + label] = true, _extends2.id = s.id, _extends2.key = "" + s.id, _extends2.dangerouslySetInnerHTML = {
      __html: s.rules
    }, _extends2))));
  }));
}

function ServerStyleManager() {
  var benefitRegistry = registry.getInstance();

  var _benefitRegistry$getR = benefitRegistry.getRegistry(),
      css = _benefitRegistry$getR.css,
      global = _benefitRegistry$getR.global,
      keyframes = _benefitRegistry$getR.keyframes,
      normalize = _benefitRegistry$getR.normalize,
      preflight = _benefitRegistry$getR.preflight,
      utilities = _benefitRegistry$getR.utilities;

  return React.createElement("div", {
    id: "benefit-container"
  }, React.createElement("script", Object.assign({}, {
    dangerouslySetInnerHTML: {
      __html: "window.benefit = " + JSON.stringify(benefitRegistry.getRegistry())
    }
  })), createContainer("preflight", preflight), createContainer("global", global), createContainer("keyframes", keyframes), createContainer("normalize", normalize), createContainer("utilities", utilities), createContainer("css", css));
}

var Box =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  var children = props.children,
      _props$className = props.className,
      className = _props$className === void 0 ? "" : _props$className,
      _props$css = props.css,
      css = _props$css === void 0 ? "" : _props$css,
      _props$important = props.important,
      important = _props$important === void 0 ? false : _props$important,
      _props$is = props.is,
      is = _props$is === void 0 ? "div" : _props$is,
      remainingProps = _objectWithoutPropertiesLoose(props, ["children", "className", "css", "important", "is"]);

  var forwardedProps = remainingProps;
  forwardedProps.ref = ref;
  return React.createElement(ConfigConsumer, null, function (_ref) {
    var styleWith = _ref.styleWith;

    if (className || css) {
      forwardedProps.className = styleWith(className + " " + css, important);
    }

    return React.createElement(is, forwardedProps, children);
  });
});

function jsx(type, props) {
  for (var _len = arguments.length, children = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    children[_key - 2] = arguments[_key];
  }

  if (props && (props.className || props.css)) {
    return React.createElement.apply(React, [Box, _extends({}, props, {
      is: type
    })].concat(children));
  }

  return React.createElement.apply(React, [type, _extends({}, props)].concat(children));
}

function Preflight(_ref) {
  var _ref$selector = _ref.selector,
      selector = _ref$selector === void 0 ? "" : _ref$selector;
  injectPreflight(selector);
  return null;
}

export { Box, ConfigConsumer, ConfigContext, ConfigProvider, Preflight, ServerStyleManager, createBenefit, createUtilitiesFromMap, createVariant, createVariantsFromMap, css, flattenColorConfig, injectGlobal, injectPreflight, jsx, keyframes, parseDeclarations, registry, theme };